// import React ,{useState, useEffect}from 'react'
// import { useNavigate , useParams} from 'react-router-dom';
// import { Button, Form,Container, Spinner } from 'react-bootstrap';
// import InputMask from 'react-input-mask';
// import moment from 'moment'
// import axios from 'axios';
// import Notification from './../../Components/assets/Modals/notification'
// import NotifyError from './../../Components/assets/Modals/errorModal'
// import {GET_CLASS, REGISTER_SCHOOL_STUDENT} from './../../url/index'


// const state_list = [
//   {Id:'',Name:'Select'},
//   {Id:'Odisha', Name:'Odisha'},
//   {Id:'Bihar', Name:'Bihar'},
//   {Id:'Jharkhand', Name:'Jharkhand'}
// ]




// const School = () => {
//   const navigate = useNavigate();
//     const {id} = useParams ();
//     const schoool_name = id == 1 ? "CTG Global School (Eng. Medium)" : "CTG Vidya Mandir (Odia Medium)" 
//     const [isLoading, setLoading] = useState(false)
//     const [IsSuccess, setSuccess] = useState(false)
//     const [eng_class_List, setEngClassList] = useState([])
//     const [odia_class_List, setOdiClassList] = useState([])
//     const[error_modal_info, setErrorModalInfo] = useState({ isHideErrorModal: true, msg: '', title: '',validationError:null})
//     const[success_modal_info, setSuccessModalInfo] = useState({  msgList: [], title: 'Success'})

//     const [currentStep, setCurrentStep] = useState(1);
//     const [same_number, setSameNumber] = useState({is_f_cell_same_as_wapp:false, is_m_cell_same_as_wapp:false});
  
//     const [formDataStep1, setFormDataStep1] = useState({ firstName: '', lastName: '', middleName:'', class:'' ,gender:'', blood_group:'', dateOfBirth:'', category:'', 
//                                                          nationality:'Indian', religion:'', mother_tongue:'', aadhar_number:'', udise_code:''});
//     const [formDataStep2, setFormDataStep2] = useState({ fatherName:'', f_qualification:'', f_Occupation: '', f_Organization:'',f_Annual_Income:'', f_Cell_Number:'',f_Wapp_Number:'',f_Email:'',f_Aadhar_Number:'',
//                                                          motherName:'', m_qualification:'', m_Occupation:'', m_Organization:'', m_Annual_Income:'', m_Cell_Number:'', m_Wapp_Number:'',m_Email:'',m_Aadhar_Number:'',
//                                                          c_House_No: '', c_street:'', c_City: '', c_Post:'', c_Block:'', c_District:'', c_zipCode: '', c_State:'',
//                                                          p_House_No: '', p_street:'', p_City: '', p_Post:'', p_Block:'', p_District:'', p_zipCode: '', p_State:'', isPresntandCurrentAddressSame:false });
//     const [formDataStep3, setFormDataStep3] = useState({ special_Abilities:'', health_Problem:'', allergy:'', lastSchool_Info:'', previous_Achievemnets:'', prev_Class:'',prev_Medium:'',prev_Mark:'',
//                                                         is_OnlyChild:null, cousin1_Class:'', cousin1_Name:'', cousin1_School_Name:'',
//                                                         cousin2_Class:'', cousin2_Name:'', cousin2_School_Name:'',
//                                                         local_guardian_address:'',local_guardian_name:'',local_guardian_contact_number1:'',local_guardian_contact_number2:'',
//                                                         accomodation_type:'', is_avail_transport:null, pickup_point:'',distance_from_school:''});
                                                         
//     const [validationStep1, setValidationStep1] = useState(false);
//     const [validationStep2, setValidationStep2] = useState(false);
//     const [validationStep3, setValidationStep3] = useState(false);

//     useEffect(() => {
//       const fetchClass = async () => {
//         try {
//           setLoading(true)
//           let response = await axios.get(`${GET_CLASS}/${id}`);
//          if(response.status == 200 && response.data.Payload)
//          // console.log(response.data.Payload);
//           {

         
//             let classList = response.data.Payload;
//              classList.unshift({ Id: 0, Name: "Select" });
//             // console.log("classList", classList);
//             if(id == 1)setEngClassList(response.data.Payload)
//             else setOdiClassList(response.data.Payload)
//           }
         
        
//         } catch (error) {
//           console.error("Error fetching fees:", error);
//         }
//         finally{
//           setLoading(false)
//         }
//       };
    
//       if (id) {
//         fetchClass();
//       }
//     }, [id]);

//     const handleNextStep = () => {
//       if (currentStep === 1) {
//         setValidationStep1(true);
//         if (validateStep1()) {
//           setCurrentStep(currentStep + 1);
//         }
//       } else if (currentStep === 2) {
//         setValidationStep2(true);
//         if (validateStep2()) {
//           setCurrentStep(currentStep + 1);
//         }
//       }
//       else if (currentStep === 3) {
//         setValidationStep3(true);
//         if (validateStep3()) {
//           setCurrentStep(currentStep + 1);
//         }
//       }
//       window.scrollTo(0, 0);
//     };
  
//     const handlePrevStep = () => {
//       setCurrentStep(currentStep - 1);
//       window.scrollTo(0, 0);
//     };
  
//     const validateStep1 = () => {
//       return( formDataStep1.class.trim() !== '' && formDataStep1.firstName.trim() !== '' && formDataStep1.lastName.trim() !== '' 
//       &&  formDataStep1.gender.trim() !== '' && 
//       (formDataStep1.dateOfBirth.trim() !== '' && !formDataStep1.dateOfBirth.trim().includes('_'))  && 
//        formDataStep1.category.trim() != ''
//       &&  formDataStep1.nationality.trim() !== '' && formDataStep1.religion.trim() !== '' && 
//       formDataStep1.mother_tongue.trim() !== '' && 
//       (formDataStep1.aadhar_number.trim() !== '' && !formDataStep1.aadhar_number.trim().includes('_')) &&
//       (formDataStep1.udise_code === '' || !formDataStep1.udise_code.includes('_')) 
//       );
//     };
  
//     const validateStep2 = () => {
//       return (
       
//         formDataStep2.fatherName.trim() !== '' &&
//         formDataStep2.f_qualification.trim() !== '' &&
//         formDataStep2.f_Occupation.trim() !== '' &&
//         formDataStep2.f_Organization.trim() !== '' &&
//         //formDataStep2.f_Annual_Income.trim() !== '' &&
//         (formDataStep2.f_Cell_Number.trim() !== '' && !formDataStep2.f_Cell_Number.trim().includes('_'))&&
//         (formDataStep2.f_Wapp_Number.trim() !== '' && !formDataStep2.f_Wapp_Number.trim().includes('_'))&&
//         formDataStep2.f_Email.trim() !== '' &&
//         (formDataStep2.f_Aadhar_Number.trim() !== '' && !formDataStep2.f_Aadhar_Number.trim().includes('_')) &&
//        // formDataStep2.c_House_No.trim() !== '' &&
//        // formDataStep2.c_street.trim() !== '' &&
//        // formDataStep2.c_City.trim() !== '' &&
//        // formDataStep2.c_Post.trim() !== '' &&
//        // formDataStep2.c_Block.trim() !== '' &&
//        // formDataStep2.c_District.trim() !== '' &&
//        // (formDataStep2.c_zipCode.trim() !== '' && !formDataStep2.c_zipCode.trim().includes('_'))&&
//        // formDataStep2.c_State.trim() !== '' &&


//         formDataStep2.motherName.trim() !== '' &&
//         formDataStep2.m_qualification.trim() !== '' &&
//         formDataStep2.m_Occupation.trim() !== '' &&
//         formDataStep2.m_Organization.trim() !== '' &&
//        // formDataStep2.m_Annual_Income.trim() !== '' &&
//         (formDataStep2.m_Cell_Number.trim() !== '' && !formDataStep2.m_Cell_Number.trim().includes('_'))&&
//         (formDataStep2.m_Wapp_Number.trim() !== '' && !formDataStep2.m_Wapp_Number.trim().includes('_'))&&
//         formDataStep2.m_Email.trim() !== '' &&
//         (formDataStep2.m_Aadhar_Number.trim() !== '' && !formDataStep2.m_Aadhar_Number.trim().includes('_')) 
        
//         //formDataStep2.p_House_No.trim() !== '' &&
// //formDataStep2.p_street.trim() !== '' &&
//        // formDataStep2.p_City.trim() !== '' &&
//         //formDataStep2.p_Post.trim() !== '' &&
//         //formDataStep2.p_Block.trim() !== '' &&
//         //formDataStep2.p_District.trim() !== '' &&
//        // (formDataStep2.p_zipCode.trim() !== '' && !formDataStep2.p_zipCode.trim().includes('_'))
//         //formDataStep2.p_State.trim() !== '' 
//       );
//     };

//     const validateStep3 = () => {
      
//       return (
//         (formDataStep3.local_guardian_contact_number1 === '' || !formDataStep3.local_guardian_contact_number1.includes('_')) &&
//         (formDataStep3.local_guardian_contact_number2 === '' || !formDataStep3.local_guardian_contact_number2.includes('_')) &&
//         formDataStep3.is_OnlyChild !== null &&
//         (formDataStep3.is_OnlyChild == true || 
//         (formDataStep3.is_OnlyChild == false && formDataStep3.cousin1_Name.trim() !== '' &&
//         formDataStep3.cousin1_Class.trim() !== '' &&
//         formDataStep3.cousin1_School_Name.trim() !== ''))  
//        // formDataStep3.accomodation_type.trim() !== '' &&
//        // (formDataStep3.accomodation_type.trim() === 'Day Scholar' ||  formDataStep3.accomodation_type.trim() === 'Day Boarding' ? (formDataStep3.is_avail_transport !== null ? true:false) : true) &&
//        //(formDataStep3.is_avail_transport == true ? ((formDataStep3.pickup_point.trim() !== '' && formDataStep3.distance_from_school.trim() !== '' ) ? true: false): true)
        
//       );
//     };

// const handleAddressCheckboxChange = (event) =>{

// if (event.target.checked) {
//   // If checkbox is checked, copy present address to permanent address
//   setFormDataStep2({ ...formDataStep2, 
//     p_House_No: formDataStep2.c_House_No, 
//     p_street:formDataStep2.c_street, 
//     p_City: formDataStep2.c_City,
//     p_Post:formDataStep2.c_Post, 
//     p_Block: formDataStep2.c_Block, 
//     p_District: formDataStep2.c_District, 
//     p_zipCode: formDataStep2.c_zipCode,
//     p_State: formDataStep2.c_State,
//     isPresntandCurrentAddressSame:true
//   });
// } else {
//   // If checkbox is unchecked, clear permanent address
//   setFormDataStep2({ ...formDataStep2, p_House_No: '', p_street:'', p_City: '', p_Post:'', p_Block:'', p_District:'', p_zipCode: '', p_State:'' ,  isPresntandCurrentAddressSame:false});
// }

// }

// const handlefSameNumberChange =(event) => {
//   setSameNumber({...same_number, is_f_cell_same_as_wapp: event.target.checked})
//   if (event.target.checked) {
//     setFormDataStep2({ ...formDataStep2, 
//       f_Wapp_Number: formDataStep2.f_Cell_Number, 
//     });
//   }
//   else{
//     setFormDataStep2({ ...formDataStep2, 
//       f_Wapp_Number: '', 
//     });
//   }
// }

// const handlemSameNumberChange =(event) => {
//   setSameNumber({...same_number, is_m_cell_same_as_wapp: event.target.checked})
//   if (event.target.checked) {
//     setFormDataStep2({ ...formDataStep2, 
//       m_Wapp_Number: formDataStep2.m_Cell_Number, 
//     });
//   }
//   else{
//     setFormDataStep2({ ...formDataStep2, 
//       m_Wapp_Number: '', 
//     });
//   }
// }



// const handleSave = async() => {
  
//   const payLoad = {
//     "SchoolTypeId": parseInt(id),
//     "ClassId": parseInt(formDataStep1.class) ,
//     "FirstName": formDataStep1.firstName,
//     "MiddleName": formDataStep1.middleName,
//     "LastName": formDataStep1.lastName,
//     "Gender": formDataStep1.gender,
//     "Dob": moment.utc(formDataStep1.dateOfBirth, "DD-MM-YYYY"),
//     "BloodGroup": formDataStep1.blood_group,
//     "Nationality": formDataStep1.nationality,
//     "Category": formDataStep1.category,
//     "Religion": formDataStep1.religion,
//     "MotherTongue": formDataStep1.mother_tongue,
//     "AdhharNumber": formDataStep1.aadhar_number.replace(/\s+/g, ''),
//     "PEN_Number": formDataStep1.udise_code.replace(/\s+/g, ''),
//     "FatherName": formDataStep2.fatherName,
//     "MotherName": formDataStep2.motherName,
//     "FatherQualification": formDataStep2.f_qualification,
//     "MotherQualification": formDataStep2.m_qualification,
//     "FatherOccupation": formDataStep2.f_Occupation,
//     "MotherOccupation": formDataStep2.m_Occupation,
//     "FatherOrganization": formDataStep2.f_Organization,
//     "MotherOrganization": formDataStep2.m_Organization,
//     "FatherIncome": parseFloat(formDataStep2.f_Annual_Income),
//     "MotherIncome": parseFloat(formDataStep2.m_Annual_Income),
//     "FatherCellNumber": formDataStep2.f_Cell_Number,
//     "MotherCellNumber": formDataStep2.m_Cell_Number,
//     "FatherWappNumber": formDataStep2.f_Wapp_Number,
//     "MotherWappNumber": formDataStep2.m_Wapp_Number,
//     "FatherEmail": formDataStep2.f_Email,
//     "MotherEmail": formDataStep2.m_Email,
//     "FatherAdhharNumber": formDataStep2.f_Aadhar_Number.replace(/\s+/g, ''),
//     "MotherAdhharNumber": formDataStep2.m_Aadhar_Number.replace(/\s+/g, ''),

//     "PresentHouseNo": formDataStep2.c_House_No,
//     "PermanentHouseNo": formDataStep2.p_House_No,
//     "PresentStreet": formDataStep2.c_street,
//     "PermanentStreet": formDataStep2.p_street,
//     "PresentCityVillage": formDataStep2.c_City,
//     "PermanentCityVillage": formDataStep2.p_City,
//     "PresentPost": formDataStep2.c_Post,
//     "PermanentPost": formDataStep2.p_Post,
//     "PresentBlock": formDataStep2.c_Block,
//     "PermanentBlock": formDataStep2.p_Block,
//     "PresentDistrict": formDataStep2.c_District,
//     "PermanentDistrict": formDataStep2.p_District,
//     "PresentState": formDataStep2.c_State,
//     "PermanentState": formDataStep2.p_State,
//     "PresentPinCode": parseInt(formDataStep2.c_zipCode),
//     "PermanentPinCode": parseInt(formDataStep2.p_zipCode),
//     "IsPresentPermanentSame": formDataStep2.isPresntandCurrentAddressSame,

//     "SpecialAbilities": formDataStep3.special_Abilities,
//     "HealthProblem": formDataStep3.health_Problem,
//     "Allergy": formDataStep3.allergy,
//     "LastSchoolInfo": formDataStep3.lastSchool_Info,
//     "LastSchoolMediumId": parseInt(formDataStep3.prev_Medium),
//     "LastSchoolClassId": parseInt(formDataStep3.prev_Class),
//     "LastSchoolMark": parseFloat(formDataStep3.prev_Mark),
//     "PreviousAchievement": formDataStep3.previous_Achievemnets,
//     "IsOnlyChild": formDataStep3.is_OnlyChild,
//     "Sibling1Name": formDataStep3.cousin1_Name,
//     "Sibling2Name": formDataStep3.cousin2_Name,
//     "Sibling1ClassId": parseInt(formDataStep3.cousin1_Class),
//     "Sibling2ClassId": parseInt(formDataStep3.cousin2_Class),
//     "Sibling1School": formDataStep3.cousin1_School_Name,
//     "Sibling2School": formDataStep3.cousin2_School_Name,
//     "LocalGuardianName": formDataStep3.local_guardian_name,
//     "LocalGuardianAddress": formDataStep3.local_guardian_address,
//     "LocalGuardianCellNumber1": formDataStep3.local_guardian_contact_number1,
//     "LocalGuardianCellNumber2": formDataStep3.local_guardian_contact_number2,
//     "AccomodationType": formDataStep3.accomodation_type,
//     "IsAvailTransport": formDataStep3.is_avail_transport,
//     "PickupPoint": formDataStep3.pickup_point,
//     "Distance": parseFloat(formDataStep3.distance_from_school)
// }

// try {
//   setLoading(true)
//  let response = await axios.post(REGISTER_SCHOOL_STUDENT, payLoad);

//  if(response.status === 201)
//  {
//    //let msg = "You have successfully registered for " + schoool_name + ". Your registration number is " + response.data.Payload + ". Thank you for showing interest for CTG."
//    let temp = []
//    temp.push("You have successfully registered for " + schoool_name)
//    temp.push("Your registration number is " + response.data.Payload)
//    temp.push("The final admission will take place after submitting the necessary documents and fee at Office")
//    setSuccessModalInfo({...success_modal_info, msgList: temp})

//    setLoading(false)
//    setSuccess(true)
//    clearFormDataStep1()
//    clearFormDataStep2()
//    clearFormDataStep3()
   
// }

// else{
//  setSuccessModalInfo({...success_modal_info, msgList: []})
//   setLoading(false)
//   setSuccess(true)
// }
// } catch (error) {
//   setLoading(false)
//   setSuccessModalInfo({...success_modal_info, msgList: []})
//   if(error.response.data)
//     {
//        if(error.response.status === 400)
//      {
      
//         if(error.response.data.Error.ValidationErrors != null)
//         {
//           const validationError =  error.response.data.Error.ValidationErrors
         
//           setErrorModalInfo({title:"Validation Error occurred!",
//            msg: error.response.data.Error.Message, 
//           validationError: validationError,
//           isHideErrorModal: false
//         })

//         }
//         else{

//           setErrorModalInfo({title:"Error occurred!",
//           msg: error.response.data.Error.Message, 
//          isHideErrorModal: false
//        })

//         }
     
//      }
//      else{

//       setErrorModalInfo({title:"Error occurred!",
//       msg: "Please contact support." , 
//      isHideErrorModal: false
//    })
//      }
//     }
//     else
//     setErrorModalInfo({title:"Error occurred!",
//       msg: "Please contact support." , 
//      isHideErrorModal: false
//    })
// }

// }

// const handleClose = () => {
//   setSuccess(false)
//   setSuccessModalInfo({...success_modal_info, msgList: []})
//   window.location.reload();
//   window.scrollTo(0, 0);
// }

// const handleCloseErrorModal = () => {
//   setSuccessModalInfo({...success_modal_info, msgList: []})
//   setErrorModalInfo({title:"",
//   msg: '', 
//  validationError: null,
//  isHideErrorModal: true
// })
// }

// const clearFormDataStep1 = () => {
//   setFormDataStep1({
//     firstName: '', 
//     lastName: '', 
//     middleName: '', 
//     class: '', 
//     gender: '', 
//     blood_group: '', 
//     dateOfBirth: '', 
//     category: '', 
//     nationality: 'Indian', 
//     religion: '', 
//     mother_tongue: '', 
//     aadhar_number: '', 
//     udise_code: ''
//   });
// };

// const clearFormDataStep2 = () => {
//   setFormDataStep2({ fatherName:'', f_qualification:'', f_Occupation: '', f_Organization:'',f_Annual_Income:'', f_Cell_Number:'',f_Wapp_Number:'',f_Email:'',f_Aadhar_Number:'',
//   motherName:'', m_qualification:'', m_Occupation:'', m_Organization:'', m_Annual_Income:'', m_Cell_Number:'', m_Wapp_Number:'',m_Email:'',m_Aadhar_Number:'',
//   c_House_No: '', c_street:'', c_City: '', c_Post:'', c_Block:'', c_District:'', c_zipCode: '', c_State:'',
//   p_House_No: '', p_street:'', p_City: '', p_Post:'', p_Block:'', p_District:'', p_zipCode: '', p_State:'', isPresntandCurrentAddressSame:false });
// };

// const clearFormDataStep3 = () => {
//   setFormDataStep3({
//     special_Abilities:'', health_Problem:'', allergy:'', lastSchool_Info:'', previous_Achievemnets:'', prev_Class:'',prev_Medium:'',prev_Mark:'',
//     is_OnlyChild:null, cousin1_Class:'', cousin1_Name:'', cousin1_School_Name:'',
//     cousin2_Class:'', cousin2_Name:'', cousin2_School_Name:'',
//     local_guardian_address:'',local_guardian_name:'',local_guardian_contact_number1:'',local_guardian_contact_number2:'',
//     accomodation_type:'', is_avail_transport:null, pickup_point:'',distance_from_school:''
//   });
// };

//   return (
//     <div className='school'>
//        <div className='container'>
//        <div className='schoolheading'>
//                <label className = 'school-label'>Registration cum Admission Form</label>
//                <br/>
              
               
//                <div>
//   {id == 1 ? (
//     <label className = 'school-label'>
//       <span >{"for CTG Global School"}</span>
//       <span className="medium-text">{" (Eng. Medium)"}</span>
//     </label>
//   ) : (
//     <label className = 'school-label'>
//       <span>{"for CTG Vidya Mandir"}</span>
//       <span className="medium-text">{" (Odia. Medium)"}</span>
//     </label>
//   )}
// </div>


//                 </div>
       

//                 <div className="container mt-2">
//         <div className="row justify-content-center">
//           <div className="col-12 col-md-8">
//              <div className="progress">
//               <div
//                 className={`progress-bar progress-bar-striped ${
//                   currentStep === 1 ? 'bg-info' : (currentStep === 2 ||  currentStep === 3 )? 'bg-warning' : 'bg-success'
//                 }`}
//                 role="progressbar"
//                 style={{ width: `${(currentStep - 1) * 50}%` }}
//               ></div>
//             </div> 
           
//               <div className="card-body">
//                 {/* Step 1 */}
//                 {currentStep === 1 && (
//                   <div>
//                     <h5 className="card-title"><span className = 'school-label'>Student Information</span></h5>
//                     <form className="mb-2">

//                     <div className="form-group">
//         <label className = 'school-label'>
//         <span className="text-danger">*</span>Class:
//         </label>
//         <select
//           className={`form-control ${validationStep1 && formDataStep1.class.trim() === '' ? 'is-invalid' : ''}`}
//           value={formDataStep1.class}
//           onChange={(e) =>
//             setFormDataStep1({ ...formDataStep1, class: e.target.value })
//           }
//         >
//          {id == 1 ? eng_class_List.map((x,y) => <option value= {x.Id} key={y}>{x.Name}</option>) : odia_class_List.map((x,y) => <option value= {x.Id} key={y}>{x.Name}</option>)}
//           {/* Add more countries as needed */}
//         </select>
//         {validationStep1 && formDataStep1.class.trim() === '' && (
//           <small className="text-danger">Class is required.</small>
//         )}
//                    </div>

//  {/* name section */}
// <div className="mb-2 parent-form">
//  <div className="parent-column">
//                       <div className="form-group">
//                         <label className = 'school-label'><span className="text-danger">*</span>First Name:</label>
//                         <input
//                           type="text"
//                           className={`form-control ${validationStep1 && formDataStep1.firstName.trim() === '' ? 'is-invalid' : ''}`}

//                           value={formDataStep1.firstName}
//                           onChange={(e) =>
//                             setFormDataStep1({ ...formDataStep1, firstName: e.target.value })
//                           }
//                         />
//                         {validationStep1 && formDataStep1.firstName.trim() === '' && (
//                           <small className="text-danger">First Name is required.</small>
//                         )}
//                       </div>
//                       </div>
//                       <div className="parent-column">
//                       <div className="form-group">
//                         <label className = 'school-label'>Middle Name:</label>
//                         <input
//                           type="text"
//                           className={`form-control`}

//                           value={formDataStep1.middleName}
//                           onChange={(e) =>
//                             setFormDataStep1({ ...formDataStep1, middleName: e.target.value })
//                           }
//                         />
//                       </div>
//                       </div>
//                       <div className="parent-column">
//                       <div className="form-group">
//                         <label className = 'school-label'><span className="text-danger">*</span>Last Name:</label>
//                         <input
//                           type="text"
//                           className={`form-control ${validationStep1 && formDataStep1.lastName.trim() === '' ? 'is-invalid' : ''}`}
//                           value={formDataStep1.lastName}
//                           onChange={(e) =>
//                             setFormDataStep1({ ...formDataStep1, lastName: e.target.value })
//                           }
//                         />
//                         {validationStep1 && formDataStep1.lastName.trim() === '' && (
//                           <small className="text-danger">Last Name is required.</small>
//                         )}
//                       </div>

//                       </div>

//                       </div>

//                       <div className="form-group">
//         <label className = 'school-label'>
//         <span className="text-danger">*</span>Gender:
//         </label>
//         <div>
//           <div className="form-check form-check-inline">
//             <input
//               type="radio"
//               className="form-check-input"
//               id="maleRadio"
//               name="gender"
//               value="Male"
//               checked={formDataStep1.gender === 'Male'}
//               onChange={() =>
//                 setFormDataStep1({ ...formDataStep1, gender: 'Male' })
//               }
//             />
//             <label className="form-check-label" htmlFor="maleRadio">
//               <span className = 'school-label'>Male</span>
//             </label>
//           </div>
//           <div className="form-check form-check-inline">
//             <input
//               type="radio"
//               className="form-check-input"
//               id="femaleRadio"
//               name="gender"
//               value="Female"
//               checked={formDataStep1.gender === 'Female'}
//               onChange={() =>
//                 setFormDataStep1({ ...formDataStep1, gender: 'Female' })
//               }
//             />
//             <label className="form-check-label" htmlFor="femaleRadio">
//             <span className = 'school-label'>Female</span>
//             </label>
//           </div>
//           {/* Add more radio buttons as needed */}
//         </div>
//         {validationStep1 && !formDataStep1.gender && (
//           <small className="text-danger">Gender is required.</small>
//         )}
//       </div>
 
                   


//       <div className="form-group">
//                         <label className = 'school-label'>Blood Group:</label>
//                         <input
//                           type="text"
//                           className={`form-control`}
//                           value={formDataStep1.blood_group}
//                           onChange={(e) =>
//                             setFormDataStep1({ ...formDataStep1, blood_group: e.target.value })
//                           }
//                         />
                       
//                       </div>

//                       <div className="form-group">
//         <label className = 'school-label'>
//         <span className="text-danger">*</span> Date of Birth:
//         </label>

//         <InputMask
//           mask="99/99/9999"
//           className={`form-control ${validationStep1 && (formDataStep1.dateOfBirth.trim() === '' || formDataStep1.dateOfBirth.trim().includes('_')) ? 'is-invalid' : ''}`}
//           value={formDataStep1.dateOfBirth}
//           onChange={(e) =>
//             setFormDataStep1({ ...formDataStep1, dateOfBirth: e.target.value })
//           }
//           placeholder="DD/MM/YYYY"
//         />
//         {validationStep1 && formDataStep1.dateOfBirth.trim() === '' && (
//           <small className="text-danger">Date of Birth is required.</small>
//         )}
//       </div>


//       <div className="form-group">
//         <label className = 'school-label'>
//         <span className="text-danger">*</span>Category:
//         </label>
//         <select
//           className={`form-control ${validationStep1 && formDataStep1.category.trim() === '' ? 'is-invalid' : ''}`}
//           value={formDataStep1.category}
//           onChange={(e) =>
//             setFormDataStep1({ ...formDataStep1, category: e.target.value })
//           }
//         >
//          <option value="" disabled>Select</option>
//   <option value={"ST"}>ST</option>
//   <option value={"SC"}>SC</option>
//   <option value={"OBC"}>OBC</option>
//   <option value={"SEBC"}>SEBC</option>
//   <option value={"Minority"}>Minority</option>
//   <option value={"General"}>General</option>
  
//         </select>
//         {validationStep1 && formDataStep1.category.trim() === '' && (
//           <small className="text-danger">Category is required.</small>
//         )}
//                    </div>

//                    <div className="form-group">
//         <label className = 'school-label'>
//         <span className="text-danger">*</span>Nationality:
//         </label>
//         <select
//           className={`form-control ${validationStep1 && formDataStep1.nationality.trim() === '' ? 'is-invalid' : ''}`}
//           value={formDataStep1.nationality}
//           onChange={(e) =>
//             setFormDataStep1({ ...formDataStep1, nationality: e.target.value })
//           }
//         >
//          <option value="" disabled>Select</option>
//   <option value={"Indian"}>Indian</option>
//   <option value={"Other"}>Other</option>
  
//         </select>
//         {validationStep1 && formDataStep1.nationality.trim() === '' && (
//           <small className="text-danger">Nationality is required.</small>
//         )}
//                    </div>

//                    <div className="form-group">
//         <label className = 'school-label'>
//         <span className="text-danger">*</span>Religion:
//         </label>
//         <select
//           className={`form-control ${validationStep1 && formDataStep1.religion.trim() === '' ? 'is-invalid' : ''}`}
//           value={formDataStep1.religion}
//           onChange={(e) =>
//             setFormDataStep1({ ...formDataStep1, religion: e.target.value })
//           }
//         >
//   <option value="" disabled>Select</option>
//   <option value={"Hinduism"}>Hinduism</option>
//   <option value={"Muslim"}>Muslim</option>
//   <option value={"Sikhisim"}>Sikhisim</option>
//   <option value={"Christian"}>Christian</option>
//   <option value={"Other"}>Other</option>
//         </select>
//         {validationStep1 && formDataStep1.religion.trim() === '' && (
//           <small className="text-danger">Religion is required.</small>
//         )}
//                    </div>

//                    <div className="form-group">
//         <label className = 'school-label'>
//         <span className="text-danger">*</span>Mother Tongue:
//         </label>
//         <select
//           className={`form-control ${validationStep1 && formDataStep1.mother_tongue.trim() === '' ? 'is-invalid' : ''}`}
//           value={formDataStep1.mother_tongue}
//           onChange={(e) =>
//             setFormDataStep1({ ...formDataStep1, mother_tongue: e.target.value })
//           }
//         >
//   <option value="" disabled>Select</option>
//   <option value={"Odia"}>Odia</option>
//   <option value={"Hindi"}>Hindi</option>
//   <option value={"Other"}>Other</option>
//         </select>
//         {validationStep1 && formDataStep1.mother_tongue.trim() === '' && (
//           <small className="text-danger">Mother Tongue is required.</small>
//         )}
//                    </div>

//                    <div className="form-group">
//         <label className = 'school-label'>
//         <span className="text-danger">*</span> Aadhar Number:
//         </label>

//         <InputMask
//           mask="9999 9999 9999"
//           className={`form-control ${validationStep1 && (formDataStep1.aadhar_number.trim() === '' || formDataStep1.aadhar_number.trim().includes('_')) ? 'is-invalid' : ''}`}
//           value={formDataStep1.aadhar_number}
//           onChange={(e) =>
//             setFormDataStep1({ ...formDataStep1, aadhar_number: e.target.value })
//           }
//           placeholder="0000 0000 0000"
//         />
//         {validationStep1 && formDataStep1.aadhar_number.trim() === '' && (
//           <small className="text-danger">Aadhar number is required.</small>
//         )}
//       </div>

//       <div className="form-group">
//         <label className = 'school-label'>
//          UDISE+ (Permanent Education Number):
//         </label>

//         <InputMask
//           mask="9999 9999 999"
//           className={`form-control ${validationStep1 && (formDataStep1.udise_code.length > 0 && formDataStep1.udise_code.includes('_')) ? 'is-invalid' : ''}`}
//           value={formDataStep1.udise_code}
//           onChange={(e) =>
//             setFormDataStep1({ ...formDataStep1, udise_code: e.target.value })
//           }
//           placeholder="0000 0000 000"
//         />
       
//       </div>


//                     </form>
//                     <div style={{ display: "flex", justifyContent: "flex-end"}}>
//                     <button  className="btn btn-primary" onClick={handleNextStep}>
//                       Next
//                     </button>
//                    </div>
//                   </div>
//                 )}

//                 {/* Step 2 */}
//                 {currentStep === 2 && (
//                   <div>
//                     <h5 className="card-title"><span className = 'school-label'>Parent Information</span></h5>
//                     <form className="mb-2 parent-form">
//                       <div className="parent-column">
//                       <h6 className = 'school-label'>Father's Info</h6>
//                       <div className="form-group">
//                         <label className = 'school-label'><span className="text-danger">*</span>Name:</label>
//                         <input
//                           type="text"
//                           className={`form-control ${validationStep2 && formDataStep2.fatherName.trim() === '' ? 'is-invalid' : ''}`}

//                           value={formDataStep2.fatherName}
//                           onChange={(e) =>
//                             setFormDataStep2({ ...formDataStep2, fatherName: e.target.value })
//                           }
//                         />
//                         {validationStep2 && formDataStep2.fatherName.trim() === '' && (
//                           <small className="text-danger">Father's Name is required.</small>
//                         )}
//                       </div>

//                       <div className="form-group">
//                         <label className = 'school-label'><span className="text-danger">*</span>Qualification:</label>
//                         <input
//                           type="text"
//                           className={`form-control ${validationStep2 && formDataStep2.f_qualification.trim() === '' ? 'is-invalid' : ''}`}

//                           value={formDataStep2.f_qualification}
//                           onChange={(e) =>
//                             setFormDataStep2({ ...formDataStep2, f_qualification: e.target.value })
//                           }
//                         />
//                         {validationStep2 && formDataStep2.f_qualification.trim() === '' && (
//                           <small className="text-danger">Father's Qualification is required.</small>
//                         )}
//                       </div>

//                       <div className="form-group">
//                         <label className = 'school-label'><span className="text-danger">*</span>Occupation:</label>
//                         <input
//                           type="text"
//                           className={`form-control ${validationStep2 && formDataStep2.f_Occupation.trim() === '' ? 'is-invalid' : ''}`}

//                           value={formDataStep2.f_Occupation}
//                           onChange={(e) =>
//                             setFormDataStep2({ ...formDataStep2, f_Occupation: e.target.value })
//                           }
//                         />
//                         {validationStep2 && formDataStep2.f_Occupation.trim() === '' && (
//                           <small className="text-danger">Father's Occupation is required.</small>
//                         )}
//                       </div>
                      

//                       <div className="form-group">
//                         <label className = 'school-label'><span className="text-danger">*</span>Organization:</label>
//                         <input
//                           type="text"
//                           className={`form-control ${validationStep2 && formDataStep2.f_Organization.trim() === '' ? 'is-invalid' : ''}`}

//                           value={formDataStep2.f_Organization}
//                           onChange={(e) =>
//                             setFormDataStep2({ ...formDataStep2, f_Organization: e.target.value })
//                           }
//                         />
//                         {validationStep2 && formDataStep2.f_Organization.trim() === '' && (
//                           <small className="text-danger">Father's Organization is required.</small>
//                         )}
//                       </div>

//                       <div className="form-group">
//                         <label className = 'school-label'>Annual Income:</label>
//                         {/* <input
//                           type="text"
//                           className={`form-control ${validationStep2 && formDataStep2.f_Annual_Income.trim() === '' ? 'is-invalid' : ''}`}

//                           value={formDataStep2.f_Annual_Income}
//                           onChange={(e) =>
//                             setFormDataStep2({ ...formDataStep2, f_Annual_Income: e.target.value })
//                           }
//                         /> */}
//                         <div class="input-group">
//         <div class="input-group-prepend">
//           <span class="input-group-text rupee-symbol">₹</span>
//         </div>
//         <input type="text" 
//          className={`form-control`}
//          id="f_Annual_Income" 
//          value={formDataStep2.f_Annual_Income}
         
//          onChange={(e) =>
//           {
//           let value = e.target.value.replace(/[^\d]/g, '')
//           if(value.length > 0)
//           {
//             let float_val = parseFloat(value)
//             if(float_val < 100000000)
//             {
//               setFormDataStep2({ ...formDataStep2, f_Annual_Income: value })
//             }
//           }
//           else{
//              setFormDataStep2({ ...formDataStep2, f_Annual_Income: value })
//           }
          
//           }
//         }
//         pattern="[0-9]*"
//          />
//         <div class="input-group-append">
//           <span class="input-group-text decimal-symbol">.00</span>
//         </div>
//       </div>
//                       </div>

//                       <div className="form-group">
//         <label className = 'school-label'>
//         <span className="text-danger">*</span>Cell Number:
//         </label>

//         <div class="input-group">
// <div class="input-group-append">
//           <span class="input-group-text ph_ext-symbol">+91</span>
//         </div>

//         <InputMask
//           mask="9999999999"
//           className={`form-control ${validationStep2 && (formDataStep2.f_Cell_Number.trim() === '' || formDataStep2.f_Cell_Number.trim().includes('_')) ? 'is-invalid' : ''}`}
//           value={formDataStep2.f_Cell_Number}
//           onChange={(e) =>
//             setFormDataStep2({ ...formDataStep2, f_Cell_Number: e.target.value, f_Wapp_Number: same_number.is_f_cell_same_as_wapp ?  e.target.value : formDataStep2.f_Wapp_Number })
//           }
//           placeholder="0000000000"
//         />
        
//       </div>
//       {validationStep2 && formDataStep2.f_Cell_Number.trim() === '' && (
//           <small className="text-danger">Father's Cell Number is required.</small>
//         )}
//       </div>  
//       <br/>
//       <div className="form-group">
//       <input
//             type="checkbox"
//             id="agreeCheckboxf"
//             checked={same_number.is_f_cell_same_as_wapp}
//             onChange={ handlefSameNumberChange}
//             className="form-check-input"
//           />
//           <span style={{ marginRight: '5px' , fontSize:'14px', color:'#0b6669'}}> {/* Add space here */}
//     Same as Cell Number?
//   </span>
// <br/>
//         <label className = 'school-label'>
//         <span className="text-danger">*</span>Whatsapp Number:
//         </label>

       
//         <div class="input-group">
// <div class="input-group-append">
//           <span class="input-group-text ph_ext-symbol">+91</span>
//         </div>
//         <InputMask
//           mask="9999999999"
//           className={`form-control ${validationStep2 && (formDataStep2.f_Wapp_Number.trim() === '' || formDataStep2.f_Wapp_Number.trim().includes('_')) ? 'is-invalid' : ''}`}
//           value={formDataStep2.f_Wapp_Number}
//           onChange={(e) =>
//             setFormDataStep2({ ...formDataStep2, f_Wapp_Number: e.target.value })
//           }
//           placeholder="0000000000"
//           disabled = {same_number.is_f_cell_same_as_wapp}
//         />
//          </div>
//         {validationStep2 && formDataStep2.f_Wapp_Number.trim() === '' && (
//           <small className="text-danger">Father's Whatsapp Number is required.</small>
//         )}
//       </div>

//       <div className="form-group">
//         <label className = 'school-label'><span className="text-danger">*</span>Email:</label>
//         <input
//           type="email"
//           className={`form-control ${validationStep2 && formDataStep2.f_Email.trim() === '' ? 'is-invalid' : ''}`}
//           value={formDataStep2.f_Email}
//           onChange={(e) =>
//             setFormDataStep2({ ...formDataStep2, f_Email: e.target.value })
//           }
//           required  
//           pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
//         />
//         {validationStep2 && formDataStep2.f_Email.trim() === '' ? (
//           <small className="text-danger">Father's Email is required.</small>
//         ) : (validationStep2 && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formDataStep2.f_Email)) && (
//           <small className="text-danger">Invalid email format.</small>)}

//       </div>

//       <div className="form-group">
//         <label className = 'school-label'>
//         <span className="text-danger">*</span>Aadhar Number:
//         </label>

//         <InputMask
//           mask="9999 9999 9999"
//           className={`form-control ${validationStep2 && (formDataStep2.f_Aadhar_Number.trim() === '' || formDataStep2.f_Aadhar_Number.trim().includes('_')) ? 'is-invalid' : ''}`}
//           value={formDataStep2.f_Aadhar_Number}
//           onChange={(e) =>
//             setFormDataStep2({ ...formDataStep2, f_Aadhar_Number: e.target.value })
//           }
//           placeholder="0000 0000 0000"
//         />
//         {validationStep2 && formDataStep2.f_Aadhar_Number.trim() === '' && (
//           <small className="text-danger">Father's Aadhar Number is required.</small>
//         )}
//       </div>
//       <br/>
      
//       <label className = 'school-label'>
//         <h6 className="school-label">Present Address:</h6> 
//         </label>
//         <br/>
//         <br/> 
//           { window.innerWidth < 768 && <br/>}  
//       <div className="form-group">
       
//         <label className = 'school-label'>
//          House No:
//         </label>
//         <input
//                           type="text"
//                           className={`form-control`}

//                           value={formDataStep2.c_House_No}
//                           onChange={(e) =>
//                             setFormDataStep2({ ...formDataStep2,
//                                c_House_No: e.target.value ,
//                                p_House_No: formDataStep2.isPresntandCurrentAddressSame ?  e.target.value : formDataStep2.p_House_No
//                             })
//                           }
//                         />
        
//       </div>

//       <div className="form-group">
//         <label className = 'school-label'>
//         Street:
//         </label>
//         <input
//                           type="text"
//                           className={`form-control`}

//                           value={formDataStep2.c_street}
//                           onChange={(e) =>
//                             setFormDataStep2({ ...formDataStep2, c_street: e.target.value ,
//                               p_street: formDataStep2.isPresntandCurrentAddressSame ?  e.target.value : formDataStep2.p_street
//                             })
//                           }
//                         />
        
//       </div>

//       <div className="form-group">
//         <label className = 'school-label'>
//          City/Village:
//         </label>
//         <input
//                           type="text"
//                           className={`form-control`}

//                           value={formDataStep2.c_City}
//                           onChange={(e) =>
//                             setFormDataStep2({ ...formDataStep2, c_City: e.target.value,
//                               p_City: formDataStep2.isPresntandCurrentAddressSame ?  e.target.value : formDataStep2.p_City
//                             })
//                           }
//                         />
       
//       </div>

//       <div className="form-group">
//         <label className = 'school-label'>
//          Post:
//         </label>
//         <input
//                           type="text"
//                           className={`form-control`}

//                           value={formDataStep2.c_Post}
//                           onChange={(e) =>
//                             setFormDataStep2({ ...formDataStep2, c_Post: e.target.value ,
//                               p_Post: formDataStep2.isPresntandCurrentAddressSame ?  e.target.value : formDataStep2.p_Post
//                             })
//                           }
//                         />
       
//       </div>

//       <div className="form-group">
//         <label className = 'school-label'>
//          Block:
//         </label>
//         <input
//                           type="text"
//                           className={`form-control`}

//                           value={formDataStep2.c_Block}
//                           onChange={(e) =>
//                             setFormDataStep2({ ...formDataStep2, c_Block: e.target.value,
//                               p_Block: formDataStep2.isPresntandCurrentAddressSame ?  e.target.value : formDataStep2.p_Block
//                             })
//                           }
//                         />
        
//       </div>

//       <div className="form-group">
//         <label className = 'school-label'>
//          District:
//         </label>
//         <input
//                           type="text"
//                           className={`form-control`}

//                           value={formDataStep2.c_District}
//                           onChange={(e) =>
//                             setFormDataStep2({ ...formDataStep2, c_District: e.target.value,
//                               p_District: formDataStep2.isPresntandCurrentAddressSame ?  e.target.value : formDataStep2.p_District
//                             })
//                           }
//                         />
       
//       </div>

//       <div className="form-group">
//         <label className = 'school-label'>
//          PIN:
//         </label>
//         <InputMask
//           mask="999999"
//           //className={`form-control ${validationStep2 && formDataStep2.c_zipCode.trim() === '' ? 'is-invalid' : ''}`}
//           className={`form-control`}
//           value={formDataStep2.c_zipCode}
//           onChange={(e) =>
//             setFormDataStep2({ ...formDataStep2, c_zipCode: e.target.value ,
//               p_zipCode: formDataStep2.isPresntandCurrentAddressSame ?  e.target.value : formDataStep2.p_zipCode
//             })
//           }
//           placeholder="000000"
//         />
        
//       </div>

//       <div className="form-group">
//         <label className = 'school-label'>
//         State:
//         </label>
//         <select
//           className={`form-control`}
//           value={formDataStep2.c_State}
//           onChange={(e) =>
//             setFormDataStep2({ ...formDataStep2, c_State: e.target.value ,
//               p_State: formDataStep2.isPresntandCurrentAddressSame ?  e.target.value : formDataStep2.p_State
//             })
//           }
//         >
//          { state_list.map((x,y) => <option value= {x.Id} key={y}>{x.Name}</option>)}
//           {/* Add more countries as needed */}
//         </select>
        
//       </div>
//                       </div>
                      
//                       <div className="parent-column">
//                       <h6 className = 'school-label'>Mother's Info</h6>
//                       <div className="form-group">
//                         <label className = 'school-label'><span className="text-danger">*</span>Name:</label>
//                         <input
//                           type="text"
//                           className={`form-control ${validationStep2 && formDataStep2.motherName.trim() === '' ? 'is-invalid' : ''}`}

//                           value={formDataStep2.motherName}
//                           onChange={(e) =>
//                             setFormDataStep2({ ...formDataStep2, motherName: e.target.value })
//                           }
//                         />
//                         {validationStep2 && formDataStep2.motherName.trim() === '' && (
//                           <small className="text-danger">Mother's Name is required.</small>
//                         )}
//                       </div>

//                       <div className="form-group">
//                         <label className = 'school-label'><span className="text-danger">*</span>Qualification:</label>
//                         <input
//                           type="text"
//                           className={`form-control ${validationStep2 && formDataStep2.m_qualification.trim() === '' ? 'is-invalid' : ''}`}

//                           value={formDataStep2.m_qualification}
//                           onChange={(e) =>
//                             setFormDataStep2({ ...formDataStep2, m_qualification: e.target.value })
//                           }
//                         />
//                         {validationStep2 && formDataStep2.m_qualification.trim() === '' && (
//                           <small className="text-danger">Mother's Qualification is required.</small>
//                         )}
//                       </div>

//                       <div className="form-group">
//                         <label className = 'school-label'><span className="text-danger">*</span>Occupation:</label>
//                         <input
//                           type="text"
//                           className={`form-control ${validationStep2 && formDataStep2.m_Occupation.trim() === '' ? 'is-invalid' : ''}`}

//                           value={formDataStep2.m_Occupation}
//                           onChange={(e) =>
//                             setFormDataStep2({ ...formDataStep2, m_Occupation: e.target.value })
//                           }
//                         />
//                         {validationStep2 && formDataStep2.m_Occupation.trim() === '' && (
//                           <small className="text-danger">Mother's Occupation is required.</small>
//                         )}
//                       </div>

//                       <div className="form-group">
//                         <label className = 'school-label'><span className="text-danger">*</span>Organization:</label>
//                         <input
//                           type="text"
//                           className={`form-control ${validationStep2 && formDataStep2.m_Organization.trim() === '' ? 'is-invalid' : ''}`}

//                           value={formDataStep2.m_Organization}
//                           onChange={(e) =>
//                             setFormDataStep2({ ...formDataStep2, m_Organization: e.target.value })
//                           }
//                         />
//                         {validationStep2 && formDataStep2.m_Organization.trim() === '' && (
//                           <small className="text-danger">Mother's Organization is required.</small>
//                         )}
//                       </div>

                      
//                       <div className="form-group">
//                         <label className = 'school-label'>Annual Income:</label>
//                         {/* <input
//                           type="text"
//                           className={`form-control ${validationStep2 && formDataStep2.m_Annual_Income.trim() === '' ? 'is-invalid' : ''}`}

//                           value={formDataStep2.m_Annual_Income}
//                           onChange={(e) =>
//                             setFormDataStep2({ ...formDataStep2, m_Annual_Income: e.target.value })
//                           }
//                         /> */}

// <div class="input-group">
//         <div class="input-group-prepend">
//           <span class="input-group-text rupee-symbol">₹</span>
//         </div>
//         <input type="text" 
//          className={`form-control`}
//          id="m_Annual_Income" 
//          value={formDataStep2.m_Annual_Income}
         
//         //  onChange={(e) =>
//         //   setFormDataStep2({ ...formDataStep2, m_Annual_Income: e.target.value.replace(/\D/g, '') })
//         // }

//         onChange={(e) =>
//           {
//           let value = e.target.value.replace(/[^\d]/g, '')
//           if(value.length > 0)
//           {
//             let float_val = parseFloat(value)
//             if(float_val < 100000000)
//             {
//               setFormDataStep2({ ...formDataStep2, m_Annual_Income: value })
//             }
//           }
//           else{
//              setFormDataStep2({ ...formDataStep2, m_Annual_Income: value })
//           }
//           //setFormDataStep3({ ...formDataStep3, prev_Mark: e.target.value.replace(/[^\d.]/g, '') })
//           }
//         }
//         pattern="[0-9]*"
//          />
//         <div class="input-group-append">
//           <span class="input-group-text decimal-symbol">.00</span>
//         </div>
//       </div>
                        
//                       </div>
                      

//                       <div className="form-group">
//         <label className = 'school-label'>
//         <span className="text-danger">*</span>Cell Number:
//         </label>
//         <div class="input-group">
// <div class="input-group-append">
//           <span class="input-group-text ph_ext-symbol">+91</span>
//         </div>
//         <InputMask
//           mask="9999999999"
//           className={`form-control ${validationStep2 && (formDataStep2.m_Cell_Number.trim() === '' || formDataStep2.m_Cell_Number.trim().includes('_')) ? 'is-invalid' : ''}`}
//           value={formDataStep2.m_Cell_Number}
//           onChange={(e) =>
//             //setFormDataStep2({ ...formDataStep2, m_Cell_Number: e.target.value })
//             setFormDataStep2({ ...formDataStep2, m_Cell_Number: e.target.value, m_Wapp_Number: same_number.is_m_cell_same_as_wapp ?  e.target.value : formDataStep2.m_Wapp_Number })
//           }
//           placeholder="0000000000"
//         />
//         </div>
//         {validationStep2 && formDataStep2.m_Cell_Number.trim() === '' && (
//           <small className="text-danger">Mother's Cell Number is required.</small>
//         )}
//       </div>
//       <br/>
      
//       <div className="form-group">

//       <input
//             type="checkbox"
//             id="agreeCheckboxm"
//             checked={same_number.is_m_cell_same_as_wapp}
//             onChange={ handlemSameNumberChange}
//             className="form-check-input"
//           />
//           <span style={{ marginRight: '5px' , fontSize:'14px', color:'#0b6669'}}> {/* Add space here */}
//     Same as Cell Number?
//   </span>
// <br/>

//         <label className = 'school-label'>
//         <span className="text-danger">*</span>Whatsapp Number:
//         </label>
//         <div class="input-group">
// <div class="input-group-append">
//           <span class="input-group-text ph_ext-symbol">+91</span>
//         </div>
//         <InputMask
//           mask="9999999999"
//           className={`form-control ${validationStep2 && (formDataStep2.m_Wapp_Number.trim() === '' || formDataStep2.m_Wapp_Number.trim().includes('_')) ? 'is-invalid' : ''}`}
//           value={formDataStep2.m_Wapp_Number}
//           onChange={(e) =>
//             setFormDataStep2({ ...formDataStep2, m_Wapp_Number: e.target.value })
//           }
//           placeholder="0000000000"
//           disabled = {same_number.is_m_cell_same_as_wapp}
//         />
//         </div>
//         {validationStep2 && formDataStep2.m_Wapp_Number.trim() === '' && (
//           <small className="text-danger">Mother's Whatsapp Number is required.</small>
//         )}
//       </div>

      
//       <div className="form-group">
//         <label className = 'school-label'><span className="text-danger">*</span>Email:</label>
//         <input
//           type="email"
//           className={`form-control ${validationStep2 && formDataStep2.m_Email.trim() === '' ? 'is-invalid' : ''}`}
//           value={formDataStep2.m_Email}
//           onChange={(e) =>
//             setFormDataStep2({ ...formDataStep2, m_Email: e.target.value })
//           }
//           required  
//           pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
//         />
//         {validationStep2 && formDataStep2.m_Email.trim() === '' ? (
//           <small className="text-danger">Mother's Email is required.</small>
//         ) : (validationStep2 && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formDataStep2.m_Email)) && (
//           <small className="text-danger">Invalid email format.</small>)}

//          {/* {validationStep2 && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formDataStep2.m_Email) && (
//            <small className="text-danger">Invalid email format.</small>
//          )} */}

//       </div>

//       <div className="form-group">
//         <label className = 'school-label'>
//         <span className="text-danger">*</span>Aadhar Number:
//         </label>

//         <InputMask
//           mask="9999 9999 9999"
//           className={`form-control ${validationStep2 && (formDataStep2.m_Aadhar_Number.trim() === '' || formDataStep2.m_Aadhar_Number.trim().includes('_')) ? 'is-invalid' : ''}`}
//           value={formDataStep2.m_Aadhar_Number}
//           onChange={(e) =>
//             setFormDataStep2({ ...formDataStep2, m_Aadhar_Number: e.target.value })
//           }
//           placeholder="0000 0000 0000"
//         />
//         {validationStep2 && formDataStep2.m_Aadhar_Number.trim() === '' && (
//           <small className="text-danger">Mother's Aadhar Number is required.</small>
//         )}
//       </div>

//       <br/>
//       <div className="form-group">
//         <label className = 'school-label'>
//         <h6 className="school-label">Permanent Address:</h6> 
//         </label>
//         <br/>
//         <input
//             type="checkbox"
//             id="agreeCheckbox"
//             checked={formDataStep2.isPresntandCurrentAddressSame}
//             onChange={handleAddressCheckboxChange}
//             className="form-check-input"
//           />
//           <span style={{ marginRight: '5px' , fontSize:'14px', color:'#0b6669'}}> {/* Add space here */}
//     Same as Present Address?
//   </span>
//   <br/>
//           {/* <br/>
//           <br/> */}
//         <label className = 'school-label'>
//          House No:
//         </label>
//         <input
//                           type="text"
//                           className={`form-control`}
//                             disabled = {formDataStep2.isPresntandCurrentAddressSame}
//                           value={formDataStep2.p_House_No}
//                           onChange={(e) =>
//                             setFormDataStep2({ ...formDataStep2, p_House_No: e.target.value })
//                           }
//                         />
       
//       </div>

//       <div className="form-group">
//         <label className = 'school-label'>
//         Street:
//         </label>
//         <input
//                           type="text"
//                           className={`form-control`}
//                           disabled = {formDataStep2.isPresntandCurrentAddressSame}
//                           value={formDataStep2.p_street}
//                           onChange={(e) =>
//                             setFormDataStep2({ ...formDataStep2, p_street: e.target.value })
//                           }
//                         />
        
//       </div>

//       <div className="form-group">
//         <label className = 'school-label'>
//          City/Village:
//         </label>
//         <input
//                           type="text"
//                           className={`form-control`}
//                           disabled = {formDataStep2.isPresntandCurrentAddressSame}
//                           value={formDataStep2.p_City}
//                           onChange={(e) =>
//                             setFormDataStep2({ ...formDataStep2, p_City: e.target.value })
//                           }
//                         />
        
//       </div>

//       <div className="form-group">
//         <label className = 'school-label'>
//          Post:
//         </label>
//         <input
//                           type="text"
//                           className={`form-control`}
//                           disabled = {formDataStep2.isPresntandCurrentAddressSame}
//                           value={formDataStep2.p_Post}
//                           onChange={(e) =>
//                             setFormDataStep2({ ...formDataStep2, p_Post: e.target.value })
//                           }
//                         />
       
//       </div>

//       <div className="form-group">
//         <label className = 'school-label'>
//          Block:
//         </label>
//         <input
//                           type="text"
//                           className={`form-control`}
//                           disabled = {formDataStep2.isPresntandCurrentAddressSame}
//                           value={formDataStep2.p_Block}
//                           onChange={(e) =>
//                             setFormDataStep2({ ...formDataStep2, p_Block: e.target.value })
//                           }
//                         />
       
//       </div>

//       <div className="form-group">
//         <label className = 'school-label'>
//          District:
//         </label>
//         <input
//                           type="text"
//                           className={`form-control`}
//                           disabled = {formDataStep2.isPresntandCurrentAddressSame}
//                           value={formDataStep2.p_District}
//                           onChange={(e) =>
//                             setFormDataStep2({ ...formDataStep2, p_District: e.target.value })
//                           }
//                         />
       
//       </div>

//       <div className="form-group">
//         <label className = 'school-label'>
//          PIN:
//         </label>
//         <InputMask
//           mask="999999"
//           disabled = {formDataStep2.isPresntandCurrentAddressSame}
//           className={`form-control`}
//           value={formDataStep2.p_zipCode}
//           onChange={(e) =>
//             setFormDataStep2({ ...formDataStep2, p_zipCode: e.target.value })
//           }
//           placeholder="000000"
//         />
        
//       </div>

//       <div className="form-group">
//         <label className = 'school-label'>
//          State:
//         </label>
//         <select
//           className={`form-control`}
//           value={formDataStep2.p_State}
//           onChange={(e) =>
//             setFormDataStep2({ ...formDataStep2, p_State: e.target.value })
//           }
//           disabled = {formDataStep2.isPresntandCurrentAddressSame}
//         >
//          { state_list.map((x,y) => <option value= {x.Id} key={y}>{x.Name}</option>)}
//           {/* Add more countries as needed */}
//         </select>
        
//       </div>

//                       </div>
                     
//                     </form>
                 
//                     <div style={{ display: "flex", justifyContent: "space-between" }}>
//   <button style={{ marginRight: '10px' }} className="btn btn-secondary" onClick={handlePrevStep}>
//     Previous
//   </button>
//   <button className="btn btn-primary" onClick={handleNextStep}>
//     Next
//   </button>
// </div>

                   
//                   </div>
//                 )}

//                 {/* Step 3 */}
//                 {currentStep === 3 && (
//                   <div>
//                     <h5 className="card-title"><span className = 'school-label'>Other Information</span></h5>
//                     {/* Add your content for Step 3 */}
//                     <form className="mb-3">

// <div className="form-group">
// <label className = 'school-label'>
// Special Abilities of Child:
// </label>
// <input
//       type="text"
//       className={`form-control`}

//       value={formDataStep3.special_Abilities}
//       onChange={(e) =>
//         setFormDataStep3({ ...formDataStep3, special_Abilities: e.target.value })
//       }
//     />

// </div>

// <div className="form-group">
//     <label className = 'school-label'>Health Problem (if any):</label>
//     <input
//       type="text"
//       className={`form-control`}
//       value={formDataStep3.health_Problem}
//       onChange={(e) =>
//         setFormDataStep3({ ...formDataStep3, health_Problem: e.target.value })
//       }
//     />
   
//   </div>

//   <div className="form-group">
//     <label className = 'school-label'>Identified Allergies (if any):</label>
//     <input
//       type="text"
//       className={`form-control`}
//       value={formDataStep3.allergy}
//       onChange={(e) =>
//         setFormDataStep3({ ...formDataStep3, allergy: e.target.value })
//       }
//     />
   
//   </div>


//   <div className="form-group">
//     <label className = 'school-label'>Name and Address of the School last attended:</label>
//     <textarea
//       className={`form-control`}
//       value={formDataStep3.lastSchool_Info}
//       onChange={(e) =>
//         setFormDataStep3({ ...formDataStep3, lastSchool_Info: e.target.value })
//       }
//     />
   
//   </div>
//   <h6 className = 'school-label'>Marks/Grade Obtained in previous class</h6>
//   <div className="mb-3 parent-form">
  
//   <div className="parent-column">
//                    <div className="form-group">
//    <label className = 'school-label'>Medium:</label>
//    <select
//           className={`form-control`}
//           value={formDataStep3.prev_Medium}
//           onChange={(e) =>
//             setFormDataStep3({ ...formDataStep3, prev_Medium: e.target.value , prev_Class:''})
//           }
//         >
// <option value="" disabled>Select</option>
//   <option value={1}>English</option>
//   <option value={2}>Odia</option>
//         </select>
   
  
//  </div>
//  </div>

  
//         <div className="parent-column">
        
//         <div className="form-group">
//         <label className = 'school-label'>
//         Class:
//         </label>
//         <select
//         disabled = {formDataStep3.prev_Medium !== '' ? false: true}
//           className={`form-control`}
//           value={formDataStep3.prev_Class}
//           onChange={(e) =>
//             setFormDataStep3({ ...formDataStep3, prev_Class: e.target.value })
//           }
//         >
//          {formDataStep3.prev_Medium == 1 ? eng_class_List.map((x,y) => <option value= {x.Id} key={y}>{x.Name}</option>) : odia_class_List.map((x,y) => <option value= {x.Id} key={y}>{x.Name}</option>)}
//           {/* Add more countries as needed */}
//         </select>
        
//                    </div>
//                    </div>

                   

//  <div className="parent-column">
//  <div className="form-group">
//         <label className = 'school-label'>
//          % of Marks:
//         </label>
      

// <div class="input-group">
//          <input 
//         type="text" 
//         class="form-control"
//          id="prev_Mark" 
//          value={formDataStep3.prev_Mark}
//         onChange={(e) =>
//           {
//           let value = e.target.value.replace(/[^\d.]/g, '')
//           if(value.length >0)
//           {
//             let float_val = parseFloat(value)
//             if(float_val < 100)
//             {
//               setFormDataStep3({ ...formDataStep3, prev_Mark: value })
//             }
//           }
//           else{
//              setFormDataStep3({ ...formDataStep3, prev_Mark: value })
//           }
//           //setFormDataStep3({ ...formDataStep3, prev_Mark: e.target.value.replace(/[^\d.]/g, '') })
//           }
//         }
//         /> 


//         <div class="input-group-append">
//           <span class="input-group-text">%</span>
//         </div>
//       </div>
       
//       </div>
//         </div>
//   </div>

//   <div className="form-group">
//     <label className = 'school-label'>Previous Achievements if Any:</label>
//     <input
//       type="text"
//       className={`form-control`}
//       value={formDataStep3.previous_Achievemnets}
//       onChange={(e) =>
//         setFormDataStep3({ ...formDataStep3, previous_Achievemnets: e.target.value })
//       }
//     />
   
//   </div>


//   <div className="form-group">
//         <label className = 'school-label'>
//         <span className="text-danger">*</span>Only Child:
//         </label>
//         <div>
//           <div className="form-check form-check-inline">
//             <input
//               type="radio"
//               className="form-check-input"
//               id="maleRadio"
//               name="gender"
//               value= {formDataStep3.is_OnlyChild}
//               checked={formDataStep3.is_OnlyChild == null ? false : formDataStep3.is_OnlyChild}
//               onChange={() =>
//                 setFormDataStep3({ ...formDataStep3, is_OnlyChild: true })
//               }
//             />
//             <label className="form-check-label" htmlFor="maleRadio">
             
//              <span className = 'school-label'>Yes</span>
//             </label>
//           </div>
//           <div className="form-check form-check-inline">
//             <input
//               type="radio"
//               className="form-check-input"
//               id="jjRadio"
//               name="is_OnlyChild"
//               value={formDataStep3.is_OnlyChild}
//               checked={formDataStep3.is_OnlyChild == null ? false : !formDataStep3.is_OnlyChild}
//               onChange={() =>
//                 setFormDataStep3({ ...formDataStep3, is_OnlyChild: false })
//               }
//             />
//             <label className="form-check-label" htmlFor="femaleRadio">
//             <span className = 'school-label'>No</span>
//             </label>
//           </div>
//           {/* Add more radio buttons as needed */}
//         </div>
//         {validationStep3 && formDataStep3.is_OnlyChild == null && (
//           <small className="text-danger"> required.</small>
//         )}
//       </div>


//       {formDataStep3.is_OnlyChild == false &&
//       <div className="mb-3 parent-form">
//         <div className="parent-column">
//         <h6 className = 'school-label'>Sibling 1 Info</h6>
//         <div className="form-group">
//    <label className = 'school-label'><span className="text-danger">*</span>Name:</label>
//    <input
//      type="text"
//      className={`form-control`}
//      value={formDataStep3.cousin1_Name}
//      onChange={(e) =>
//        setFormDataStep3({ ...formDataStep3, cousin1_Name: e.target.value })
//      }
//    />
//    {validationStep3 && formDataStep3.cousin1_Name.trim() === '' && (
//           <small className="text-danger"> required.</small>
//         )}
//  </div>

//  <div className="form-group">
//         <label className = 'school-label'>
//         <span className="text-danger">*</span>Class:
//         </label>
//         <select
//           className={`form-control`}
//           value={formDataStep3.cousin1_Class}
//           onChange={(e) =>
//             setFormDataStep3({ ...formDataStep3, cousin1_Class: e.target.value })
//           }
//         >
//          {eng_class_List.map((x,y) => <option value= {x.Id} key={y}>{x.Name}</option>)}
//           {/* Add more countries as needed */}
//         </select>
//         {validationStep3 && formDataStep3.cousin1_Class.trim() === '' && (
//           <small className="text-danger"> required.</small>
//         )}
//                    </div>

//                    <div className="form-group">
//    <label className = 'school-label'><span className="text-danger">*</span>School Name:</label>
//    <input
//      type="text"
//      className={`form-control`}
//      value={formDataStep3.cousin1_School_Name}
//      onChange={(e) =>
//        setFormDataStep3({ ...formDataStep3, cousin1_School_Name: e.target.value })
//      }
//    />
//    {validationStep3 && formDataStep3.cousin1_School_Name.trim() === '' && (
//           <small className="text-danger"> required.</small>
//         )}
//  </div> 
//         </div>

//         <div className="parent-column">
//         <h6 className = 'school-label'>Sibling 2 Info</h6>
//         <div className="form-group">
//    <label className = 'school-label'>Name:</label>
//    <input
//      type="text"
//      className={`form-control`}
//      value={formDataStep3.cousin2_Name}
//      onChange={(e) =>
//        setFormDataStep3({ ...formDataStep3, cousin2_Name: e.target.value })
//      }
//    />
  
//  </div>

//  <div className="form-group">
//         <label className = 'school-label'>
//         Class:
//         </label>
//         <select
//           className={`form-control`}
//           value={formDataStep3.cousin2_Class}
//           onChange={(e) =>
//             setFormDataStep3({ ...formDataStep3, cousin2_Class: e.target.value })
//           }
//         >
//          {odia_class_List.map((x,y) => <option value= {x.Id} key={y}>{x.Name}</option>)}
//           {/* Add more countries as needed */}
//         </select>
        
//                    </div>

//                    <div className="form-group">
//    <label className = 'school-label'>School Name:</label>
//    <input
//      type="text"
//      className={`form-control`}
//      value={formDataStep3.cousin2_School_Name}
//      onChange={(e) =>
//        setFormDataStep3({ ...formDataStep3, cousin2_School_Name: e.target.value })
//      }
//    />
  
//  </div> 
//         </div>
//       </div>
// }

// <h6 className = 'school-label'>Local Guardian Information</h6>

// <div className="form-group">
//     <label className = 'school-label'>Name:</label>
//     <input
//       type="text"
//       className={`form-control`}
//       value={formDataStep3.local_guardian_name}
//       onChange={(e) =>
//         setFormDataStep3({ ...formDataStep3, local_guardian_name: e.target.value })
//       }
//     />
   
//   </div>

//   <div className="form-group">
//     <label className = 'school-label'>Address:</label>
//     <textarea
//       className={`form-control`}
//       value={formDataStep3.local_guardian_address}
//       onChange={(e) =>
//         setFormDataStep3({ ...formDataStep3, local_guardian_address: e.target.value })
//       }
//     />
   
//   </div>
//   <div className="mb-3 parent-form">
//   <div className="parent-column">
// <div className="form-group">
// <label className = 'school-label'>
//  Contact Number 1:
// </label>



// <div class="input-group">
// <div class="input-group-append">
//           <span class="input-group-text ph_ext-symbol">+91</span>
//         </div>

// <InputMask
// mask="9999999999"
// className={`form-control ${validationStep3 && (formDataStep3.local_guardian_contact_number1.length > 0 && formDataStep3.local_guardian_contact_number1.includes('_')) ? 'is-invalid' : ''}`}

// value={formDataStep3.local_guardian_contact_number1}
// onChange={(e) =>
// setFormDataStep3({ ...formDataStep3, local_guardian_contact_number1: e.target.value })
// }
// placeholder="0000000000"
// />


       
//       </div>

// </div>
// </div>
// <div className="parent-column">
// <div className="form-group">
// <label className = 'school-label'>
// Contact Number 2:
// </label>



// <div class="input-group">
// <div class="input-group-append">
//           <span class="input-group-text ph_ext-symbol">+91</span>
//         </div>
        
//         <InputMask
// mask="9999999999"
// className={`form-control ${validationStep3 && (formDataStep3.local_guardian_contact_number2.length > 0 && formDataStep3.local_guardian_contact_number2.includes('_')) ? 'is-invalid' : ''}`}

// value={formDataStep3.local_guardian_contact_number2}
// onChange={(e) =>
// setFormDataStep3({ ...formDataStep3, local_guardian_contact_number2: e.target.value })
// }
// placeholder="0000000000"
// />


       
//       </div>
// </div>
// </div>
// </div>

// <div className="form-group">
//         <label className = 'school-label'>
//         Accomodation:
//         </label>
//         <div>
//           <div className="form-check form-check-inline">
//             <input
//               type="radio"
//               className="form-check-input"
//               id="scholarRadio"
//               name="scholarRadio"
//               value= {formDataStep3.accomodation_type}
//               checked={formDataStep3.accomodation_type === 'Day Scholar'}
//               onChange={() =>
//                 setFormDataStep3({ ...formDataStep3, accomodation_type: 'Day Scholar' })
//               }
//             />
//             <label className="form-check-label" htmlFor="scholarRadio">
//             <span className = 'school-label'>Day Scholar</span>
//             </label>
//           </div>
//           <div className="form-check form-check-inline">
//             <input
//               type="radio"
//               className="form-check-input"
//               id="dayboarding"
//               name="dayboarding"
//               value= {formDataStep3.accomodation_type}
//               checked={formDataStep3.accomodation_type === 'Day Boarding'}
//               onChange={() =>
//                 setFormDataStep3({ ...formDataStep3, accomodation_type: 'Day Boarding' })
//               }
//             />
//             <label className="form-check-label" htmlFor="dayboarding">
             
//              <span className = 'school-label'>Day Boarding</span>
//             </label>
//           </div>

//           <div className="form-check form-check-inline">
//             <input
//               type="radio"
//               className="form-check-input"
//               id="Residential"
//               name="Residential"
//               value= {formDataStep3.accomodation_type}
//               checked={formDataStep3.accomodation_type === 'Residential'}
//               onChange={() =>
//                 setFormDataStep3({ ...formDataStep3,
//                    accomodation_type: 'Residential',
//                    is_avail_transport: false,
//                    pickup_point: null,
//                    distance_from_school: null
//                   })
//               }
//             />
//             <label className="form-check-label" htmlFor="Residential">
              
//               <span className = 'school-label'>Residential</span>
//             </label>
//           </div>
//           {/* Add more radio buttons as needed */}
//         </div>
        
//       </div>

// {formDataStep3.accomodation_type !== 'Residential' && formDataStep3.accomodation_type !== '' &&
// <div className="form-group">
//         <label className = 'school-label'>
//         Avail School Transport?
//         </label>
//         <div>
//           <div className="form-check form-check-inline">
//             <input
//               type="radio"
//               className="form-check-input"
//               id="is_avail_transporttrueRadio"
//               name="transport"
//               value= {formDataStep3.is_avail_transport}
//               checked={formDataStep3.is_avail_transport == null ? false : formDataStep3.is_avail_transport}
//               onChange={() =>
//                 setFormDataStep3({ ...formDataStep3, is_avail_transport: true })
//               }

//             />
//             <label className="form-check-label" htmlFor="is_avail_transporttrueRadio">
//             <span className = 'school-label'>Yes</span>
//             </label>
//           </div>
//           <div className="form-check form-check-inline">
//             <input
//               type="radio"
//               className="form-check-input"
//               id="is_avail_transportfalseRadio"
//               name="transport"
//               value={formDataStep3.is_avail_transport}
//               checked={formDataStep3.is_avail_transport == null ? false : !formDataStep3.is_avail_transport}
//               onChange={() =>
//                 setFormDataStep3({ ...formDataStep3, is_avail_transport: false })
//               }
//             />
//             <label className="form-check-label" htmlFor="is_avail_transportfalseRadio">
//             <span className = 'school-label'>No</span>
//             </label>
//           </div>
//           {/* Add more radio buttons as needed */}
//         </div>
       
//       </div>
// }
      

//  { formDataStep3.is_avail_transport === true && 
 
//   <div>
//   <div className="form-group">
//     <label className = 'school-label'>PickUp Point:</label>
//     <input
//       type="text"
//       className={`form-control ${validationStep3 && formDataStep3.pickup_point.trim() === '' ? 'is-invalid' : ''}`}
//       value={formDataStep3.pickup_point}
//       onChange={(e) =>
//         setFormDataStep3({ ...formDataStep3, pickup_point: e.target.value })
//       }
//     />
    
//   </div>

//   <div className="form-group">
// <label className = 'school-label'>
// Distance of house from School in KM:
// </label>

// {/* <InputMask
// mask="99"
// className={`form-control ${validationStep3 && formDataStep3.distance_from_school.trim() === '' ? 'is-invalid' : ''}`}
// value={formDataStep3.distance_from_school}
// onChange={(e) =>
// setFormDataStep3({ ...formDataStep3, distance_from_school: e.target.value })
// }
// placeholder="00"
// /> */}

// <div class="input-group">
//          <input 
//         type="text" 
//         class="form-control"
//          id="distance_from_school" 
//          //placeholder="Enter percentage"
//          value={formDataStep3.distance_from_school}
//         onChange={(e) =>{
//           let value = e.target.value.replace(/[^\d.]/g, '')
//           if(value.length >0)
//           {
//             let float_val = parseFloat(value)
//             if(float_val < 100)
//             {
//               setFormDataStep3({ ...formDataStep3, distance_from_school: value })
//             }
//           }
//           else{
//              setFormDataStep3({ ...formDataStep3, distance_from_school: value })
//           }
          
//         }
          
//           }
          
//         /> 


//         <div class="input-group-append">
//           <span class="input-group-text">KM</span>
//         </div>
//       </div>

// </div>
  
//   </div>
  
// } 

// </form>

// <div style={{ display: "flex", justifyContent: "space-between" }}>
//   <button style={{ marginRight: '10px' }} className="btn btn-secondary" onClick={handlePrevStep}>
//     Previous
//   </button>
//   <button className="btn btn-primary" onClick={handleNextStep}>
//     Next
//   </button>
// </div>

//                   </div>
//                 )}


//                    {currentStep === 4 && (
//                   <div>
//                     <h5 className="card-title"><span className = 'school-label'>Final Step</span></h5>
//                     <h6 className = 'school-label'>You are almost done. Please Click on Submit to Complete the Registration.</h6>

//                     <div style={{ display: "flex", justifyContent: "space-between" , marginTop:'100px'}}>
//   <button style={{ marginRight: '10px' }} className="btn btn-secondary" onClick={handlePrevStep}>
//     Previous
//   </button>
//   <button className="btn btn-primary position-relative" onClick={handleSave} disabled={isLoading}>
 
//     Submit
//     {isLoading && (
//         <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>
//       )}
//   </button>
// </div>
//                   </div>
//                 )}
//               </div>
           
             

//           </div>
//         </div>
//       </div>
      
//       </div>

// <Notification
// IsSuccess = {IsSuccess}
// handleClose = {handleClose}
// msgList = {success_modal_info.msgList}
// title = {"Success"}
// />

// {!error_modal_info.isHideErrorModal && <NotifyError
// isHide = {error_modal_info.isHideErrorModal}
//  handleCloseErrorModal ={handleCloseErrorModal}
//   title = {error_modal_info.title}
//    message = {error_modal_info.msg}
//     Errors ={error_modal_info.validationError}
// />} 
//          </div>
//   )
// }

// export default School




import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import InputMask from 'react-input-mask';
import moment from 'moment';
import axios from 'axios';
import Notification from './../../Components/assets/Modals/notification';
import NotifyError from './../../Components/assets/Modals/errorModal';
import { GET_CLASS, REGISTER_SCHOOL_STUDENT } from './../../url/index';

/* ─── Themes ──────────────────────────────────────────────────────────────
   id=1 → CTG Global School  : navy / sky blue
   id=2 → CTG Vidya Mandir   : royal purple
─────────────────────────────────────────────────────────────────────────── */
const THEMES = {
  1: {
    pageBg:        '#07101f',
    cardBg: '#f4f7f6',
    bannerBg:      '#060e1c',
    accent:        '#38bdf8',
    accentDim:     'rgba(56,189,248,0.1)',
    accentMid:     'rgba(56,189,248,0.25)',
    label:         '#07101f',
    hlabel:         '#38bdf8',
    inputBg:     '#ffffff',
    inputBorder:   'rgba(56,189,248,0.2)',
    inputColor:     '#060e1c',
    radioColor:    '#060e1c',
    btn:           '#0284c7',
    btnSecondary:  '#1e3a5f',
    sectionBorder: 'rgba(56,189,248,0.15)',
    progressFill:  '#0284c7',
    stepActiveBg:  '#0284c7',
    panelHeadColor:'#38bdf8',
    tag:           'ENG. MEDIUM  ·  CTG Global School',
    name:          'CTG Global School',
    medium:        'English Medium',
  },
  2: {
    pageBg:        '#12082a',
    cardBg: '#f4f7f6',
    bannerBg:      '#0e0520',
    accent:        '#a78bfa',
    accentDim:     'rgba(139,92,246,0.12)',
    accentMid:     'rgba(139,92,246,0.28)',
    label:         '#12082a',
    hlabel:         '#a78bfa',
    inputBg:       '#ffffff',
    inputBorder:   'rgba(139,92,246,0.22)',
    inputColor:    '#12082a',
    radioColor:    '#12082a',
    btn:           '#6d28d9',
    btnSecondary:  '#2e1065',
    sectionBorder: 'rgba(139,92,246,0.18)',
    progressFill:  '#6d28d9',
    stepActiveBg:  '#6d28d9',
    panelHeadColor:'#a78bfa',
    tag:           'ODIA MEDIUM  ·  CTG Vidya Mandir',
    name:          'CTG Vidya Mandir',
    medium:        'Odia Medium',
  },
};

const state_list = [
  { Id:'', Name:'Select' },
  { Id:'Odisha', Name:'Odisha' },
  { Id:'Bihar', Name:'Bihar' },
  { Id:'Jharkhand', Name:'Jharkhand' },
];

/* ─── Atoms ──────────────────────────────────────────────────────────────── */
function FL({ children, req, t }) {
  return (
    <label style={{ display:'block', fontSize:11, fontWeight:500, letterSpacing:'0.06em', textTransform:'uppercase', color:t.label, marginBottom:6 }}>
      {children}{req && <span style={{ color:t.accent, marginLeft:3 }}>*</span>}
    </label>
  );
}

function Inp({ t, err, style, ...p }) {
  const [f, sf] = useState(false);
  return (
    <input {...p}
      onFocus={e => { sf(true); p.onFocus?.(e); }}
      onBlur={e  => { sf(false); p.onBlur?.(e); }}
      style={{ width:'100%', padding:'10px 14px', borderRadius:10, background:t.inputBg, color:t.inputColor, fontSize:14,
        border:`1px solid ${f ? t.accent : err ? '#f87171' : t.inputBorder}`, outline:'none',
        transition:'border-color 0.2s', boxSizing:'border-box', fontFamily:'inherit', ...style }}
    />
  );
}

function Sel({ t, err, children, disabled, ...p }) {
  const [f, sf] = useState(false);
  return (
    <select {...p} disabled={disabled} onFocus={() => sf(true)} onBlur={() => sf(false)}
      style={{ width:'100%', padding:'10px 14px', borderRadius:10, background:t.inputBg, color:t.inputColor, fontSize:14,
        border:`1px solid ${f ? t.accent : err ? '#f87171' : t.inputBorder}`, outline:'none',
        transition:'border-color 0.2s', appearance:'none', cursor: disabled ? 'not-allowed' : 'pointer',
        boxSizing:'border-box', opacity: disabled ? 0.5 : 1 }}
    >{children}</select>
  );
}

function TA({ t, err, ...p }) {
  const [f, sf] = useState(false);
  return (
    <textarea {...p} onFocus={() => sf(true)} onBlur={() => sf(false)}
      style={{ width:'100%', padding:'10px 14px', borderRadius:10, background:t.inputBg, color:t.inputColor, fontSize:14,
        border:`1px solid ${f ? t.accent : err ? '#f87171' : t.inputBorder}`, outline:'none',
        transition:'border-color 0.2s', resize:'vertical', minHeight:80,
        boxSizing:'border-box', fontFamily:'inherit' }}
    />
  );
}

function Masked({ t, err, style, ...p }) {
  const [f, sf] = useState(false);
  return (
    <InputMask {...p} onFocus={() => sf(true)} onBlur={() => sf(false)}
      style={{ width:'100%', padding:'10px 14px', borderRadius:10, background:t.inputBg, color:t.inputColor, fontSize:14,
        border:`1px solid ${f ? t.accent : err ? '#f87171' : t.inputBorder}`, outline:'none',
        transition:'border-color 0.2s', boxSizing:'border-box', fontFamily:'inherit', ...style }}
    />
  );
}

function PhoneInput({ t, err, value, onChange, disabled, placeholder }) {
  return (
    <div style={{ display:'flex', borderRadius:10, overflow:'hidden', border:`1px solid ${err ? '#f87171' : t.inputBorder}`, opacity: disabled ? 0.5 : 1 }}>
      <span style={{ background:t.accentDim, color:t.accent, padding:'10px 12px', fontSize:13, fontWeight:600, whiteSpace:'nowrap', borderRight:`1px solid ${t.inputBorder}`, flexShrink:0 }}>+91</span>
      <InputMask mask="9999999999" value={value} onChange={onChange} disabled={disabled} placeholder={placeholder || '0000000000'}
        style={{ flex:1, padding:'10px 14px', background:t.inputBg, color:t.inputColor, fontSize:14, border:'none', outline:'none', fontFamily:'inherit' }}
      />
    </div>
  );
}

function ErrMsg({ msg }) {
  if (!msg) return null;
  return <p style={{ color:'#f87171', fontSize:12, marginTop:4, marginBottom:0 }}>{msg}</p>;
}

function SecHead({ children, t }) {
  return (
    <div style={{ display:'flex', alignItems:'center', gap:10, padding:'14px 0 10px', borderBottom:`1px solid ${t.sectionBorder}`, marginBottom:16, marginTop:8 }}>
      <span style={{ width:3, height:16, borderRadius:2, background:t.accent, display:'inline-block', flexShrink:0 }} />
      <span style={{ fontSize:11, fontWeight:700, letterSpacing:'0.12em', textTransform:'uppercase', color:t.accent }}>{children}</span>
    </div>
  );
}

function Btn({ t, variant='primary', loading, children, ...p }) {
  const [hov, sh] = useState(false);
  const bg = variant === 'primary' ? t.btn : variant === 'secondary' ? t.btnSecondary : '#7f1d1d';
  return (
    <button {...p} onMouseEnter={() => sh(true)} onMouseLeave={() => sh(false)}
      style={{ padding:'11px 28px', borderRadius:10, border:'none', background: hov ? bg+'cc' : bg,
        color:'#fff', fontWeight:600, fontSize:14, cursor: p.disabled ? 'not-allowed' : 'pointer',
        letterSpacing:'0.04em', transition:'background 0.18s', display:'flex', alignItems:'center',
        gap:8, opacity: p.disabled ? 0.6 : 1 }}
    >
      {loading && <span style={{ width:14, height:14, border:'2px solid rgba(255,255,255,0.4)', borderTopColor:'#fff', borderRadius:'50%', display:'inline-block', animation:'spin 0.7s linear infinite' }} />}
      {children}
    </button>
  );
}

function Checkbox({ t, checked, onChange, label }) {
  return (
    <label style={{ display:'inline-flex', alignItems:'center', gap:8, cursor:'pointer', fontSize:13, color:t.label, marginBottom:8 }}>
      <span style={{ width:18, height:18, borderRadius:5, border:`2px solid ${checked ? t.accent : t.inputBorder}`, background: checked ? t.accentDim : 'transparent', display:'inline-flex', alignItems:'center', justifyContent:'center', flexShrink:0, transition:'all 0.15s' }}>
        {checked && <span style={{ color:t.accent, fontSize:12, fontWeight:700 }}>✓</span>}
      </span>
      <input type="checkbox" checked={checked} onChange={onChange} style={{ display:'none' }} />
      {label}
    </label>
  );
}

function RadioGroup({ t, options, value, onChange, name }) {
  return (
    <div style={{ display:'flex', flexWrap:'wrap', gap:12, marginTop:6 }}>
      {options.map(opt => (
        <label key={String(opt.value)} style={{ display:'inline-flex', alignItems:'center', gap:8, cursor:'pointer', fontSize:14, color:t.radioColor }}>
          <span style={{ width:18, height:18, borderRadius:'50%', border:`2px solid ${value === opt.value ? t.accent : t.inputBorder}`, background:'transparent', display:'inline-flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
            {value === opt.value && <span style={{ width:8, height:8, borderRadius:'50%', background:t.accent, display:'inline-block' }} />}
          </span>
          <input type="radio" name={name} value={String(opt.value)} checked={value === opt.value} onChange={() => onChange(opt.value)} style={{ display:'none' }} />
          {opt.label}
        </label>
      ))}
    </div>
  );
}

/* ─── Step Progress Bar ──────────────────────────────────────────────────── */
const STEPS = [
  { label:'Student Info', icon:'👤' },
  { label:'Parent Info',  icon:'👨‍👩‍👧' },
  { label:'Other Info',   icon:'📋' },
  { label:'Submit',       icon:'✉️' },
];

function StepBar({ current, t }) {
  return (
    <div style={{ padding:'0 0 28px', position:'relative' }}>
      <div style={{ position:'absolute', top:15, left:0, right:0, height:1, background:t.sectionBorder, zIndex:0 }} />
      <div style={{ position:'absolute', top:15, left:0, height:1, background:t.progressFill, zIndex:1, transition:'width 0.4s ease', width:`${((current-1)/3)*100}%` }} />
      <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', position:'relative', zIndex:2 }}>
        {STEPS.map((s, i) => {
          const idx = i + 1;
          const done   = idx < current;
          const active = idx === current;
          return (
            <div key={s.label} style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:8 }}>
              <div style={{ width:30, height:30, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, fontWeight:700,
                background: done ? t.btn : active ? t.stepActiveBg : t.btnSecondary,
                border:`2px solid ${done || active ? t.accent : t.inputBorder}`,
                color: done || active ? '#fff' : '#64748b',
                transition:'all 0.3s',
              }}>
                {done ? '✓' : idx}
              </div>
              <span style={{ fontSize:10, fontWeight:600, letterSpacing:'0.06em', textTransform:'uppercase',
                color: active ? t.accent : done ? t.sectionColor : '#64748b',
                transition:'color 0.3s',
                whiteSpace:'nowrap' }}>{s.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

/* ─── Grid helpers ───────────────────────────────────────────────────────── */
function Grid({ children }) {
  return <div style={{ display:'grid', gridTemplateColumns:'repeat(2, 1fr)', gap:16 }} className="sch-grid">{children}</div>;
}
function Grid3({ children }) {
  return <div style={{ display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:16 }} className="sch-3col">{children}</div>;
}
function Span2({ children }) {
  return <div style={{ gridColumn:'span 2' }} className="sch-span2">{children}</div>;
}
function TwoCol({ children, gap }) {
  return <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap: gap || 20 }} className="sch-2col">{children}</div>;
}

/* ─── Income field ───────────────────────────────────────────────────────── */
function IncomeField({ t, value, onChange }) {
  return (
    <div style={{ display:'flex', borderRadius:10, overflow:'hidden', border:`1px solid ${t.inputBorder}` }}>
      <span style={{ background:t.accentDim, color:t.accent, padding:'10px 12px', fontSize:14, fontWeight:600, borderRight:`1px solid ${t.inputBorder}`, flexShrink:0 }}>₹</span>
      <input type="text" value={value} onChange={onChange} pattern="[0-9]*"
        style={{ flex:1, padding:'10px 14px', background:t.inputBg, color:t.inputColor, fontSize:14, border:'none', outline:'none', fontFamily:'inherit' }} />
      <span style={{ background:t.accentDim, color:t.label, padding:'10px 12px', fontSize:13, borderLeft:`1px solid ${t.inputBorder}`, flexShrink:0 }}>.00</span>
    </div>
  );
}

/* ─── Suffix field ───────────────────────────────────────────────────────── */
function SuffixField({ t, value, onChange, suffix }) {
  return (
    <div style={{ display:'flex', borderRadius:10, overflow:'hidden', border:`1px solid ${t.inputBorder}` }}>
      <input type="text" value={value} onChange={onChange}
        style={{ flex:1, padding:'10px 14px', background:t.inputBg, color:t.inputColor, fontSize:14, border:'none', outline:'none', fontFamily:'inherit' }} />
      <span style={{ background:t.accentDim, color:t.label, padding:'10px 12px', fontSize:13, borderLeft:`1px solid ${t.inputBorder}`, flexShrink:0 }}>{suffix}</span>
    </div>
  );
}

/* ─── Main Component ─────────────────────────────────────────────────────── */
const School = () => {
  const { id } = useParams();
  const t = THEMES[id] || THEMES[1];

  const [isLoading, setLoading]         = useState(false);
  const [IsSuccess, setSuccess]         = useState(false);
  const [eng_class_List, setEngList]    = useState([]);
  const [odia_class_List, setOdiaList]  = useState([]);
  const [errorModal, setErrorModal]     = useState({ isHideErrorModal:true, msg:'', title:'', validationError:null });
  const [successModal, setSuccessModal] = useState({ msgList:[], title:'Success' });
  const [currentStep, setCurrentStep]   = useState(1);
  const [sameNum, setSameNum]           = useState({ f:false, m:false });

  const initS1 = { firstName:'', lastName:'', middleName:'', class:'', gender:'', blood_group:'', dateOfBirth:'', category:'', nationality:'Indian', religion:'', mother_tongue:'', aadhar_number:'', udise_code:'' };
  const initS2 = {
    fatherName:'', f_qualification:'', f_Occupation:'', f_Organization:'', f_Annual_Income:'', f_Cell_Number:'', f_Wapp_Number:'', f_Email:'', f_Aadhar_Number:'',
    motherName:'', m_qualification:'', m_Occupation:'', m_Organization:'', m_Annual_Income:'', m_Cell_Number:'', m_Wapp_Number:'', m_Email:'', m_Aadhar_Number:'',
    c_House_No:'', c_street:'', c_City:'', c_Post:'', c_Block:'', c_District:'', c_zipCode:'', c_State:'',
    p_House_No:'', p_street:'', p_City:'', p_Post:'', p_Block:'', p_District:'', p_zipCode:'', p_State:'', isPresntandCurrentAddressSame:false,
  };
  const initS3 = {
    special_Abilities:'', health_Problem:'', allergy:'', lastSchool_Info:'', previous_Achievemnets:'', prev_Class:'', prev_Medium:'', prev_Mark:'',
    is_OnlyChild:null, cousin1_Class:'', cousin1_Name:'', cousin1_School_Name:'', cousin2_Class:'', cousin2_Name:'', cousin2_School_Name:'',
    local_guardian_address:'', local_guardian_name:'', local_guardian_contact_number1:'', local_guardian_contact_number2:'',
    accomodation_type:'', is_avail_transport:null, pickup_point:'', distance_from_school:'',
  };

  const [s1, setS1] = useState(initS1);
  const [s2, setS2] = useState(initS2);
  const [s3, setS3] = useState(initS3);
  const [v1, setV1] = useState(false);
  const [v2, setV2] = useState(false);
  const [v3, setV3] = useState(false);

  useEffect(() => {
    const fetchClass = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${GET_CLASS}/${id}`);
        if (res.status === 200 && res.data.Payload) {
          const list = [...res.data.Payload];
          list.unshift({ Id:0, Name:'Select' });
          id == 1 ? setEngList(list) : setOdiaList(list);
        }
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    };
    if (id) fetchClass();
  }, [id]);

  const classList = id == 1 ? eng_class_List : odia_class_List;

  const ok1 = () =>
    s1.class.trim() !== '' && s1.firstName.trim() !== '' && s1.lastName.trim() !== '' &&
    s1.gender.trim() !== '' && s1.dateOfBirth.trim() !== '' && !s1.dateOfBirth.includes('_') &&
    s1.category.trim() !== '' && s1.nationality.trim() !== '' && s1.religion.trim() !== '' &&
    s1.mother_tongue.trim() !== '' && s1.aadhar_number.trim() !== '' && !s1.aadhar_number.includes('_') &&
    (s1.udise_code === '' || !s1.udise_code.includes('_'));

  const ok2 = () =>
    s2.fatherName.trim() !== '' && s2.f_qualification.trim() !== '' && s2.f_Occupation.trim() !== '' && s2.f_Organization.trim() !== '' &&
    s2.f_Cell_Number.trim() !== '' && !s2.f_Cell_Number.includes('_') &&
    s2.f_Wapp_Number.trim() !== '' && !s2.f_Wapp_Number.includes('_') &&
    s2.f_Email.trim() !== '' && s2.f_Aadhar_Number.trim() !== '' && !s2.f_Aadhar_Number.includes('_') &&
    s2.motherName.trim() !== '' && s2.m_qualification.trim() !== '' && s2.m_Occupation.trim() !== '' && s2.m_Organization.trim() !== '' &&
    s2.m_Cell_Number.trim() !== '' && !s2.m_Cell_Number.includes('_') &&
    s2.m_Wapp_Number.trim() !== '' && !s2.m_Wapp_Number.includes('_') &&
    s2.m_Email.trim() !== '' && s2.m_Aadhar_Number.trim() !== '' && !s2.m_Aadhar_Number.includes('_');

  const ok3 = () =>
    (s3.local_guardian_contact_number1 === '' || !s3.local_guardian_contact_number1.includes('_')) &&
    (s3.local_guardian_contact_number2 === '' || !s3.local_guardian_contact_number2.includes('_')) &&
    s3.is_OnlyChild !== null &&
    (s3.is_OnlyChild === true || (s3.cousin1_Name.trim() !== '' && s3.cousin1_Class.trim() !== '' && s3.cousin1_School_Name.trim() !== ''));

  const next = () => {
    if (currentStep === 1) { setV1(true); if (ok1()) setCurrentStep(2); }
    else if (currentStep === 2) { setV2(true); if (ok2()) setCurrentStep(3); }
    else if (currentStep === 3) { setV3(true); if (ok3()) setCurrentStep(4); }
    window.scrollTo(0, 0);
  };
  const prev = () => { setCurrentStep(c => c - 1); window.scrollTo(0, 0); };

  const handleAddrCheck = e => {
    if (e.target.checked) {
      setS2({ ...s2, p_House_No:s2.c_House_No, p_street:s2.c_street, p_City:s2.c_City, p_Post:s2.c_Post,
        p_Block:s2.c_Block, p_District:s2.c_District, p_zipCode:s2.c_zipCode, p_State:s2.c_State, isPresntandCurrentAddressSame:true });
    } else {
      setS2({ ...s2, p_House_No:'', p_street:'', p_City:'', p_Post:'', p_Block:'', p_District:'', p_zipCode:'', p_State:'', isPresntandCurrentAddressSame:false });
    }
  };

  const handleFSame = e => {
    setSameNum({ ...sameNum, f:e.target.checked });
    setS2({ ...s2, f_Wapp_Number: e.target.checked ? s2.f_Cell_Number : '' });
  };
  const handleMSame = e => {
    setSameNum({ ...sameNum, m:e.target.checked });
    setS2({ ...s2, m_Wapp_Number: e.target.checked ? s2.m_Cell_Number : '' });
  };

  const numOnly = v => v.replace(/[^\d]/g, '');
  const decOnly = (v, max) => {
    const c = v.replace(/[^\d.]/g, '');
    if (c.length > 0 && parseFloat(c) >= max) return v;
    return c;
  };

  const handleSave = async () => {
    const payload = {
      SchoolTypeId:parseInt(id), ClassId:parseInt(s1.class),
      FirstName:s1.firstName, MiddleName:s1.middleName, LastName:s1.lastName,
      Gender:s1.gender, Dob:moment.utc(s1.dateOfBirth,'DD/MM/YYYY'),
      BloodGroup:s1.blood_group, Nationality:s1.nationality, Category:s1.category,
      Religion:s1.religion, MotherTongue:s1.mother_tongue,
      AdhharNumber:s1.aadhar_number.replace(/\s+/g,''), PEN_Number:s1.udise_code.replace(/\s+/g,''),
      FatherName:s2.fatherName, MotherName:s2.motherName,
      FatherQualification:s2.f_qualification, MotherQualification:s2.m_qualification,
      FatherOccupation:s2.f_Occupation, MotherOccupation:s2.m_Occupation,
      FatherOrganization:s2.f_Organization, MotherOrganization:s2.m_Organization,
      FatherIncome:parseFloat(s2.f_Annual_Income)||0, MotherIncome:parseFloat(s2.m_Annual_Income)||0,
      FatherCellNumber:s2.f_Cell_Number, MotherCellNumber:s2.m_Cell_Number,
      FatherWappNumber:s2.f_Wapp_Number, MotherWappNumber:s2.m_Wapp_Number,
      FatherEmail:s2.f_Email, MotherEmail:s2.m_Email,
      FatherAdhharNumber:s2.f_Aadhar_Number.replace(/\s+/g,''), MotherAdhharNumber:s2.m_Aadhar_Number.replace(/\s+/g,''),
      PresentHouseNo:s2.c_House_No, PermanentHouseNo:s2.p_House_No,
      PresentStreet:s2.c_street, PermanentStreet:s2.p_street,
      PresentCityVillage:s2.c_City, PermanentCityVillage:s2.p_City,
      PresentPost:s2.c_Post, PermanentPost:s2.p_Post,
      PresentBlock:s2.c_Block, PermanentBlock:s2.p_Block,
      PresentDistrict:s2.c_District, PermanentDistrict:s2.p_District,
      PresentState:s2.c_State, PermanentState:s2.p_State,
      PresentPinCode:parseInt(s2.c_zipCode)||0, PermanentPinCode:parseInt(s2.p_zipCode)||0,
      IsPresentPermanentSame:s2.isPresntandCurrentAddressSame,
      SpecialAbilities:s3.special_Abilities, HealthProblem:s3.health_Problem, Allergy:s3.allergy,
      LastSchoolInfo:s3.lastSchool_Info, LastSchoolMediumId:parseInt(s3.prev_Medium)||0,
      LastSchoolClassId:parseInt(s3.prev_Class)||0, LastSchoolMark:parseFloat(s3.prev_Mark)||0,
      PreviousAchievement:s3.previous_Achievemnets, IsOnlyChild:s3.is_OnlyChild,
      Sibling1Name:s3.cousin1_Name, Sibling2Name:s3.cousin2_Name,
      Sibling1ClassId:parseInt(s3.cousin1_Class)||0, Sibling2ClassId:parseInt(s3.cousin2_Class)||0,
      Sibling1School:s3.cousin1_School_Name, Sibling2School:s3.cousin2_School_Name,
      LocalGuardianName:s3.local_guardian_name, LocalGuardianAddress:s3.local_guardian_address,
      LocalGuardianCellNumber1:s3.local_guardian_contact_number1, LocalGuardianCellNumber2:s3.local_guardian_contact_number2,
      AccomodationType:s3.accomodation_type, IsAvailTransport:s3.is_avail_transport,
      PickupPoint:s3.pickup_point, Distance:parseFloat(s3.distance_from_school)|| null,
    };
    try {
      setLoading(true);
      const res = await axios.post(REGISTER_SCHOOL_STUDENT, payload);
      if (res.status === 201) {
        setSuccessModal({ msgList:[
          `You have successfully registered for ${t.name}`,
          `Your registration number is ${res.data.Payload}`,
          'The final admission will take place after submitting the necessary documents and fee at Office',
        ], title:'Success' });
        setSuccess(true);
        setS1(initS1); setS2(initS2); setS3(initS3);
      } else { setSuccess(true); }
    } catch (err) {
      if (err.response?.data) {
        const e = err.response.data.Error;
        if (err.response.status === 400) {
          setErrorModal({ title: e.ValidationErrors ? 'Validation Error' : 'Error occurred!', msg:e.Message, validationError:e.ValidationErrors||null, isHideErrorModal:false });
        } else { setErrorModal({ title:'Error occurred!', msg:'Please contact support.', validationError:null, isHideErrorModal:false }); }
      } else { setErrorModal({ title:'Error occurred!', msg:'Please contact support.', validationError:null, isHideErrorModal:false }); }
    } finally { setLoading(false); }
  };

  const handleClose    = () => { setSuccess(false); window.location.reload(); window.scrollTo(0,0); };
  const handleCloseErr = () => setErrorModal({ title:'', msg:'', validationError:null, isHideErrorModal:true });

  const maskedStyle = {
    width:'100%', padding:'10px 14px', borderRadius:10,
    background:t.inputBg, color:t.inputColor, fontSize:14,
    border:`1px solid ${t.inputBorder}`, outline:'none', boxSizing:'border-box', fontFamily:'inherit',
  };

  return (
    <div style={{ minHeight:'100vh', background:t.pageBg, fontFamily:"'DM Sans','Segoe UI',sans-serif", paddingBottom:'4rem' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=DM+Sans:wght@300;400;500;600&display=swap');
        @keyframes spin { to { transform:rotate(360deg); } }
        input::placeholder, textarea::placeholder { color:rgba(148,163,184,0.35); }
        select option { background:#1e293b; color:#f8fafc; }
        .sch-grid  { display:grid; grid-template-columns:1fr 1fr; gap:16px; }
        .sch-3col  { display:grid; grid-template-columns:1fr 1fr 1fr; gap:16px; }
        .sch-2col  { display:grid; grid-template-columns:1fr 1fr; gap:20px; }
        .sch-span2 { grid-column:span 2; }
        @media(max-width:620px){
          .sch-grid,.sch-3col,.sch-2col { grid-template-columns:1fr; }
          .sch-span2 { grid-column:span 1; }
        }
        select { appearance:none; }
      `}</style>

      {/* ── Banner ── */}
      <div style={{ background:t.bannerBg, borderBottom:`1px solid ${t.sectionBorder}`, padding:'1.8rem 1.5rem 1.5rem', position:'relative', overflow:'hidden' }}>
        <div style={{ position:'absolute', top:-50, right:-50, width:220, height:220, borderRadius:'50%', border:`1px solid ${t.accentMid}`, pointerEvents:'none' }} />
        <div style={{ position:'absolute', top:10, right:30, width:120, height:120, borderRadius:'50%', border:`1px solid ${t.sectionBorder}`, pointerEvents:'none' }} />
        <div style={{ maxWidth:900, margin:'0 auto' }}>
          <div style={{ display:'inline-flex', alignItems:'center', gap:6, background:t.accentDim, border:`1px solid ${t.accentMid}`, borderRadius:100, padding:'4px 12px', marginBottom:12 }}>
            <span style={{ width:6, height:6, borderRadius:'50%', background:t.accent, display:'inline-block' }} />
            <span style={{ fontSize:10, fontWeight:600, letterSpacing:'0.1em', textTransform:'uppercase', color:t.accent }}>{t.tag}</span>
          </div>
          <h1 style={{ fontFamily:"'Playfair Display',Georgia,serif", fontSize:'clamp(1.4rem,4vw,2.1rem)', fontWeight:700, color:'#fff', margin:'0 0 4px', lineHeight:1.1 }}>
            Registration &amp; Admission Form
          </h1>
          <p style={{ fontSize:14, color:t.hlabel, margin:0, fontWeight:300 }}>for {t.name} &nbsp;·&nbsp; {t.medium}</p>
        </div>
      </div>

      {/* ── Form Card ── */}
      <div style={{ maxWidth:900, margin:'2rem auto', padding:'0 1rem' }}>
        <div style={{ background:t.cardBg, border:`1px solid ${t.accent}25`, borderRadius:20, padding:'28px 28px 32px' }}>
          <StepBar current={currentStep} t={t} />

          {/* ══ STEP 1 — Student Info ══════════════════════════════════════ */}
          {currentStep === 1 && (
            <>
              <SecHead t={t}>Student Information</SecHead>
              <div className="sch-grid" style={{ marginBottom:16 }}>
                <Span2>
                  <FL req t={t}>Class</FL>
                  <Sel t={t} err={v1 && !s1.class} value={s1.class} onChange={e => setS1({...s1, class:e.target.value})}>
                    {classList.map((x,i) => <option key={i} value={x.Id}>{x.Name}</option>)}
                  </Sel>
                  {v1 && !s1.class && <ErrMsg msg="Class is required" />}
                </Span2>

                <div><FL req t={t}>First Name</FL>
                  <Inp t={t} err={v1 && !s1.firstName.trim()} type="text" value={s1.firstName} onChange={e => setS1({...s1, firstName:e.target.value})} />
                  {v1 && !s1.firstName.trim() && <ErrMsg msg="Required" />}
                </div>

                <div><FL t={t}>Middle Name</FL>
                  <Inp t={t} type="text" value={s1.middleName} onChange={e => setS1({...s1, middleName:e.target.value})} />
                </div>

                <div><FL req t={t}>Last Name</FL>
                  <Inp t={t} err={v1 && !s1.lastName.trim()} type="text" value={s1.lastName} onChange={e => setS1({...s1, lastName:e.target.value})} />
                  {v1 && !s1.lastName.trim() && <ErrMsg msg="Required" />}
                </div>

                <div>
                  <FL req t={t}>Gender</FL>
                  <RadioGroup t={t} name="gender" options={[{value:'Male',label:'Male'},{value:'Female',label:'Female'}]} value={s1.gender} onChange={v => setS1({...s1, gender:v})} />
                  {v1 && !s1.gender && <ErrMsg msg="Required" />}
                </div>

                <div><FL t={t}>Blood Group</FL>
                  <Inp t={t} type="text" placeholder="e.g. O+" value={s1.blood_group} onChange={e => setS1({...s1, blood_group:e.target.value})} />
                </div>

                <div><FL req t={t}>Date of Birth</FL>
                  <Masked t={t} mask="99/99/9999" placeholder="DD/MM/YYYY" err={v1 && (!s1.dateOfBirth || s1.dateOfBirth.includes('_'))} value={s1.dateOfBirth} onChange={e => setS1({...s1, dateOfBirth:e.target.value})} />
                  {v1 && (!s1.dateOfBirth || s1.dateOfBirth.includes('_')) && <ErrMsg msg="Required" />}
                </div>

                <div><FL req t={t}>Category</FL>
                  <Sel t={t} err={v1 && !s1.category} value={s1.category} onChange={e => setS1({...s1, category:e.target.value})}>
                    <option value="" disabled>Select</option>
                    {['ST','SC','OBC','SEBC','Minority','General'].map(c => <option key={c} value={c}>{c}</option>)}
                  </Sel>
                  {v1 && !s1.category && <ErrMsg msg="Required" />}
                </div>

                <div><FL req t={t}>Nationality</FL>
                  <Sel t={t} value={s1.nationality} onChange={e => setS1({...s1, nationality:e.target.value})}>
                    <option value="Indian">Indian</option>
                    <option value="Other">Other</option>
                  </Sel>
                </div>

                <div><FL req t={t}>Religion</FL>
                  <Sel t={t} err={v1 && !s1.religion} value={s1.religion} onChange={e => setS1({...s1, religion:e.target.value})}>
                    <option value="" disabled>Select</option>
                    {['Hinduism','Muslim','Sikhisim','Christian','Other'].map(r => <option key={r} value={r}>{r}</option>)}
                  </Sel>
                  {v1 && !s1.religion && <ErrMsg msg="Required" />}
                </div>

                <div><FL req t={t}>Mother Tongue</FL>
                  <Sel t={t} err={v1 && !s1.mother_tongue} value={s1.mother_tongue} onChange={e => setS1({...s1, mother_tongue:e.target.value})}>
                    <option value="" disabled>Select</option>
                    {['Odia','Hindi','Other'].map(m => <option key={m} value={m}>{m}</option>)}
                  </Sel>
                  {v1 && !s1.mother_tongue && <ErrMsg msg="Required" />}
                </div>

                <div><FL req t={t}>Aadhaar Number</FL>
                  <Masked t={t} mask="9999 9999 9999" placeholder="0000 0000 0000" err={v1 && (!s1.aadhar_number || s1.aadhar_number.includes('_'))} value={s1.aadhar_number} onChange={e => setS1({...s1, aadhar_number:e.target.value})} />
                  {v1 && (!s1.aadhar_number || s1.aadhar_number.includes('_')) && <ErrMsg msg="Required" />}
                </div>

                <div><FL t={t}>UDISE+ / PEN Number</FL>
                  <Masked t={t} mask="9999 9999 999" placeholder="0000 0000 000" value={s1.udise_code} onChange={e => setS1({...s1, udise_code:e.target.value})} />
                </div>
              </div>
              <div style={{ display:'flex', justifyContent:'flex-end', marginTop:20 }}>
                <Btn t={t} onClick={next}>Next →</Btn>
              </div>
            </>
          )}

          {/* ══ STEP 2 — Parent Info ═══════════════════════════════════════ */}
          {currentStep === 2 && (
            <>
              <div className="sch-2col">
                {/* Father */}
                <div>
                  <SecHead t={t}>Father's Information</SecHead>
                  <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
                    <div><FL req t={t}>Name</FL><Inp t={t} err={v2 && !s2.fatherName.trim()} type="text" value={s2.fatherName} onChange={e => setS2({...s2, fatherName:e.target.value})} />{v2 && !s2.fatherName.trim() && <ErrMsg msg="Required" />}</div>
                    <div><FL req t={t}>Qualification</FL><Inp t={t} err={v2 && !s2.f_qualification.trim()} type="text" value={s2.f_qualification} onChange={e => setS2({...s2, f_qualification:e.target.value})} /></div>
                    <div><FL req t={t}>Occupation</FL><Inp t={t} err={v2 && !s2.f_Occupation.trim()} type="text" value={s2.f_Occupation} onChange={e => setS2({...s2, f_Occupation:e.target.value})} /></div>
                    <div><FL req t={t}>Organization</FL><Inp t={t} err={v2 && !s2.f_Organization.trim()} type="text" value={s2.f_Organization} onChange={e => setS2({...s2, f_Organization:e.target.value})} /></div>
                    <div><FL t={t}>Annual Income</FL><IncomeField t={t} value={s2.f_Annual_Income} onChange={e => { const v = numOnly(e.target.value); if (!v || parseFloat(v) < 100000000) setS2({...s2, f_Annual_Income:v}); }} /></div>
                    <div><FL req t={t}>Cell Number</FL><PhoneInput t={t} err={v2 && (!s2.f_Cell_Number || s2.f_Cell_Number.includes('_'))} value={s2.f_Cell_Number} onChange={e => setS2({...s2, f_Cell_Number:e.target.value, f_Wapp_Number: sameNum.f ? e.target.value : s2.f_Wapp_Number})} />{v2 && (!s2.f_Cell_Number || s2.f_Cell_Number.includes('_')) && <ErrMsg msg="Required" />}</div>
                    <div>
                      <Checkbox t={t} checked={sameNum.f} onChange={handleFSame} label="Same as Cell Number?" />
                      <FL req t={t}>WhatsApp Number</FL>
                      <PhoneInput t={t} err={v2 && (!s2.f_Wapp_Number || s2.f_Wapp_Number.includes('_'))} value={s2.f_Wapp_Number} onChange={e => setS2({...s2, f_Wapp_Number:e.target.value})} disabled={sameNum.f} />
                      {v2 && (!s2.f_Wapp_Number || s2.f_Wapp_Number.includes('_')) && <ErrMsg msg="Required" />}
                    </div>
                    <div><FL req t={t}>Email</FL><Inp t={t} err={v2 && !s2.f_Email.trim()} type="email" value={s2.f_Email} onChange={e => setS2({...s2, f_Email:e.target.value})} />{v2 && !s2.f_Email.trim() && <ErrMsg msg="Required" />}</div>
                    <div><FL req t={t}>Aadhaar Number</FL><Masked t={t} mask="9999 9999 9999" placeholder="0000 0000 0000" err={v2 && (!s2.f_Aadhar_Number || s2.f_Aadhar_Number.includes('_'))} value={s2.f_Aadhar_Number} onChange={e => setS2({...s2, f_Aadhar_Number:e.target.value})} /></div>
                  </div>
                </div>

                {/* Mother */}
                <div>
                  <SecHead t={t}>Mother's Information</SecHead>
                  <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
                    <div><FL req t={t}>Name</FL><Inp t={t} err={v2 && !s2.motherName.trim()} type="text" value={s2.motherName} onChange={e => setS2({...s2, motherName:e.target.value})} /></div>
                    <div><FL req t={t}>Qualification</FL><Inp t={t} type="text" value={s2.m_qualification} onChange={e => setS2({...s2, m_qualification:e.target.value})} /></div>
                    <div><FL req t={t}>Occupation</FL><Inp t={t} type="text" value={s2.m_Occupation} onChange={e => setS2({...s2, m_Occupation:e.target.value})} /></div>
                    <div><FL req t={t}>Organization</FL><Inp t={t} type="text" value={s2.m_Organization} onChange={e => setS2({...s2, m_Organization:e.target.value})} /></div>
                    <div><FL t={t}>Annual Income</FL><IncomeField t={t} value={s2.m_Annual_Income} onChange={e => { const v = numOnly(e.target.value); if (!v || parseFloat(v) < 100000000) setS2({...s2, m_Annual_Income:v}); }} /></div>
                    <div><FL req t={t}>Cell Number</FL><PhoneInput t={t} err={v2 && (!s2.m_Cell_Number || s2.m_Cell_Number.includes('_'))} value={s2.m_Cell_Number} onChange={e => setS2({...s2, m_Cell_Number:e.target.value, m_Wapp_Number: sameNum.m ? e.target.value : s2.m_Wapp_Number})} /></div>
                    <div>
                      <Checkbox t={t} checked={sameNum.m} onChange={handleMSame} label="Same as Cell Number?" />
                      <FL req t={t}>WhatsApp Number</FL>
                      <PhoneInput t={t} err={v2 && (!s2.m_Wapp_Number || s2.m_Wapp_Number.includes('_'))} value={s2.m_Wapp_Number} onChange={e => setS2({...s2, m_Wapp_Number:e.target.value})} disabled={sameNum.m} />
                    </div>
                    <div><FL req t={t}>Email</FL><Inp t={t} type="email" value={s2.m_Email} onChange={e => setS2({...s2, m_Email:e.target.value})} /></div>
                    <div><FL req t={t}>Aadhaar Number</FL><Masked t={t} mask="9999 9999 9999" placeholder="0000 0000 0000" err={v2 && (!s2.m_Aadhar_Number || s2.m_Aadhar_Number.includes('_'))} value={s2.m_Aadhar_Number} onChange={e => setS2({...s2, m_Aadhar_Number:e.target.value})} /></div>
                  </div>
                </div>
              </div>

              {/* Addresses */}
              <div className="sch-2col" style={{ marginTop:24 }}>
                <div>
                  <SecHead t={t}>Present Address</SecHead>
                  <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
                    {[['House No','c_House_No','p_House_No'],['Street','c_street','p_street'],['City / Village','c_City','p_City'],['Post','c_Post','p_Post'],['Block','c_Block','p_Block'],['District','c_District','p_District']].map(([lbl,ck,pk]) => (
                      <div key={ck}><FL t={t}>{lbl}</FL><Inp t={t} type="text" value={s2[ck]} onChange={e => setS2({...s2, [ck]:e.target.value, [pk]: s2.isPresntandCurrentAddressSame ? e.target.value : s2[pk] })} /></div>
                    ))}
                    <div><FL t={t}>PIN</FL><Masked t={t} mask="999999" placeholder="000000" value={s2.c_zipCode} onChange={e => setS2({...s2, c_zipCode:e.target.value, p_zipCode: s2.isPresntandCurrentAddressSame ? e.target.value : s2.p_zipCode})} /></div>
                    <div><FL t={t}>State</FL><Sel t={t} value={s2.c_State} onChange={e => setS2({...s2, c_State:e.target.value, p_State: s2.isPresntandCurrentAddressSame ? e.target.value : s2.p_State})}>{state_list.map((x,i) => <option key={i} value={x.Id}>{x.Name}</option>)}</Sel></div>
                  </div>
                </div>

                <div>
                  <SecHead t={t}>Permanent Address</SecHead>
                  <Checkbox t={t} checked={s2.isPresntandCurrentAddressSame} onChange={handleAddrCheck} label="Same as Present Address?" />
                  <div style={{ display:'flex', flexDirection:'column', gap:12, marginTop:8 }}>
                    {[['House No','p_House_No'],['Street','p_street'],['City / Village','p_City'],['Post','p_Post'],['Block','p_Block'],['District','p_District']].map(([lbl,pk]) => (
                      <div key={pk}><FL t={t}>{lbl}</FL><Inp t={t} type="text" disabled={s2.isPresntandCurrentAddressSame} value={s2[pk]} onChange={e => setS2({...s2, [pk]:e.target.value})} style={{ opacity: s2.isPresntandCurrentAddressSame ? 0.5 : 1 }} /></div>
                    ))}
                    <div><FL t={t}>PIN</FL><Masked t={t} mask="999999" placeholder="000000" disabled={s2.isPresntandCurrentAddressSame} value={s2.p_zipCode} onChange={e => setS2({...s2, p_zipCode:e.target.value})} style={{ opacity: s2.isPresntandCurrentAddressSame ? 0.5 : 1 }} /></div>
                    <div><FL t={t}>State</FL><Sel t={t} value={s2.p_State} disabled={s2.isPresntandCurrentAddressSame} onChange={e => setS2({...s2, p_State:e.target.value})}>{state_list.map((x,i) => <option key={i} value={x.Id}>{x.Name}</option>)}</Sel></div>
                  </div>
                </div>
              </div>

              <div style={{ display:'flex', justifyContent:'space-between', marginTop:24 }}>
                <Btn t={t} variant="secondary" onClick={prev}>← Previous</Btn>
                <Btn t={t} onClick={next}>Next →</Btn>
              </div>
            </>
          )}

          {/* ══ STEP 3 — Other Info ════════════════════════════════════════ */}
          {currentStep === 3 && (
            <>
              <SecHead t={t}>Child &amp; Health Information</SecHead>
              <div className="sch-grid" style={{ marginBottom:16 }}>
                <div><FL t={t}>Special Abilities</FL><Inp t={t} type="text" value={s3.special_Abilities} onChange={e => setS3({...s3, special_Abilities:e.target.value})} /></div>
                <div><FL t={t}>Health Problem (if any)</FL><Inp t={t} type="text" value={s3.health_Problem} onChange={e => setS3({...s3, health_Problem:e.target.value})} /></div>
                <div><FL t={t}>Identified Allergies</FL><Inp t={t} type="text" value={s3.allergy} onChange={e => setS3({...s3, allergy:e.target.value})} /></div>
                <div><FL t={t}>Previous Achievements</FL><Inp t={t} type="text" value={s3.previous_Achievemnets} onChange={e => setS3({...s3, previous_Achievemnets:e.target.value})} /></div>
                <Span2><FL t={t}>Last School Name &amp; Address</FL><TA t={t} value={s3.lastSchool_Info} onChange={e => setS3({...s3, lastSchool_Info:e.target.value})} rows={2} /></Span2>
              </div>

              <SecHead t={t}>Previous Class Results</SecHead>
              <div className="sch-3col" style={{ marginBottom:20 }}>
                <div><FL t={t}>Medium</FL>
                  <Sel t={t} value={s3.prev_Medium} onChange={e => setS3({...s3, prev_Medium:e.target.value, prev_Class:''})}>
                    <option value="" disabled>Select</option>
                    <option value={1}>English</option>
                    <option value={2}>Odia</option>
                  </Sel>
                </div>
                <div><FL t={t}>Class</FL>
                  <Sel t={t} value={s3.prev_Class} disabled={!s3.prev_Medium} onChange={e => setS3({...s3, prev_Class:e.target.value})}>
                    {(s3.prev_Medium == 1 ? eng_class_List : odia_class_List).map((x,i) => <option key={i} value={x.Id}>{x.Name}</option>)}
                  </Sel>
                </div>
                <div><FL t={t}>% of Marks</FL>
                  <SuffixField t={t} value={s3.prev_Mark} onChange={e => setS3({...s3, prev_Mark: decOnly(e.target.value, 100)})} suffix="%" />
                </div>
              </div>

              <SecHead t={t}>Sibling Information</SecHead>
              <div style={{ marginBottom:16 }}>
                <FL req t={t}>Is this child an Only Child?</FL>
                <RadioGroup t={t} name="onlychild" options={[{value:true,label:'Yes'},{value:false,label:'No'}]} value={s3.is_OnlyChild} onChange={v => setS3({...s3, is_OnlyChild:v})} />
                {v3 && s3.is_OnlyChild === null && <ErrMsg msg="Required" />}
              </div>

              {s3.is_OnlyChild === false && (
                <div className="sch-2col" style={{ marginBottom:16 }}>
                  {[{h:'Sibling 1',req:true,n:'cousin1'},{h:'Sibling 2',req:false,n:'cousin2'}].map(({h,req:r,n}) => (
                    <div key={n}>
                      <p style={{ fontSize:12, fontWeight:600, color:t.accent, textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:12 }}>{h}</p>
                      <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
                        <div><FL req={r} t={t}>Name</FL><Inp t={t} err={v3 && r && !s3[n+'_Name'].trim()} type="text" value={s3[n+'_Name']} onChange={e => setS3({...s3, [n+'_Name']:e.target.value})} /></div>
                        <div><FL req={r} t={t}>Class</FL>
                          <Sel t={t} err={v3 && r && !s3[n+'_Class']} value={s3[n+'_Class']} onChange={e => setS3({...s3, [n+'_Class']:e.target.value})}>
                            {eng_class_List.map((x,i) => <option key={i} value={x.Id}>{x.Name}</option>)}
                          </Sel>
                        </div>
                        <div><FL req={r} t={t}>School Name</FL><Inp t={t} err={v3 && r && !s3[n+'_School_Name'].trim()} type="text" value={s3[n+'_School_Name']} onChange={e => setS3({...s3, [n+'_School_Name']:e.target.value})} /></div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              <SecHead t={t}>Local Guardian Information</SecHead>
              <div className="sch-grid" style={{ marginBottom:16 }}>
                <div><FL t={t}>Name</FL><Inp t={t} type="text" value={s3.local_guardian_name} onChange={e => setS3({...s3, local_guardian_name:e.target.value})} /></div>
                <Span2><FL t={t}>Address</FL><TA t={t} value={s3.local_guardian_address} onChange={e => setS3({...s3, local_guardian_address:e.target.value})} rows={2} /></Span2>
                <div><FL t={t}>Contact Number 1</FL><PhoneInput t={t} value={s3.local_guardian_contact_number1} onChange={e => setS3({...s3, local_guardian_contact_number1:e.target.value})} /></div>
                <div><FL t={t}>Contact Number 2</FL><PhoneInput t={t} value={s3.local_guardian_contact_number2} onChange={e => setS3({...s3, local_guardian_contact_number2:e.target.value})} /></div>
              </div>

              <SecHead t={t}>Accommodation &amp; Transport</SecHead>
              <div style={{ marginBottom:16 }}>
                <FL t={t}>Accommodation Type</FL>
                <RadioGroup t={t} name="accom"
                  options={['Day Scholar','Day Boarding','Residential'].map(v => ({value:v, label:v}))}
                  value={s3.accomodation_type}
                  onChange={v => setS3({...s3, accomodation_type:v, is_avail_transport: v==='Residential' ? false : s3.is_avail_transport, pickup_point: v==='Residential' ? '' : s3.pickup_point, distance_from_school: v==='Residential' ? '' : s3.distance_from_school})}
                />
              </div>

              {s3.accomodation_type && s3.accomodation_type !== 'Residential' && (
                <div style={{ marginBottom:16 }}>
                  <FL t={t}>Avail School Transport?</FL>
                  <RadioGroup t={t} name="transport" options={[{value:true,label:'Yes'},{value:false,label:'No'}]} value={s3.is_avail_transport} onChange={v => setS3({...s3, is_avail_transport:v})} />
                </div>
              )}

              {s3.is_avail_transport === true && (
                <div className="sch-grid" style={{ marginBottom:16 }}>
                  <div><FL t={t}>Pickup Point</FL><Inp t={t} type="text" value={s3.pickup_point} onChange={e => setS3({...s3, pickup_point:e.target.value})} /></div>
                  <div><FL t={t}>Distance from School (KM)</FL>
                    <SuffixField t={t} value={s3.distance_from_school} onChange={e => setS3({...s3, distance_from_school: decOnly(e.target.value, 100)})} suffix="KM" />
                  </div>
                </div>
              )}

              <div style={{ display:'flex', justifyContent:'space-between', marginTop:20 }}>
                <Btn t={t} variant="secondary" onClick={prev}>← Previous</Btn>
                <Btn t={t} onClick={next}>Next →</Btn>
              </div>
            </>
          )}

          {/* ══ STEP 4 — Submit ════════════════════════════════════════════ */}
          {currentStep === 4 && (
            <>
              <SecHead t={t}>Final Step</SecHead>
              <div style={{ textAlign:'center', padding:'40px 20px' }}>
                <div style={{ fontSize:48, marginBottom:16 }}>🎓</div>
                <h2 style={{ fontFamily:"'Playfair Display',serif", color:'#fff', fontSize:'1.4rem', marginBottom:8 }}>Almost Done!</h2>
                <p style={{ color:t.label, fontSize:15, fontWeight:300, maxWidth:400, margin:'0 auto 32px', lineHeight:1.7 }}>
                  Please review your information and click Submit to complete the registration for {t.name}.
                </p>
                <div style={{ display:'flex', gap:12, justifyContent:'center', flexWrap:'wrap' }}>
                  <Btn t={t} variant="secondary" onClick={prev}>← Previous</Btn>
                  <Btn t={t} onClick={handleSave} loading={isLoading} disabled={isLoading}>
                    {isLoading ? 'Submitting...' : 'Submit Registration'}
                  </Btn>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <Notification
  IsSuccess={IsSuccess}
  handleClose={handleClose}
  msgList={successModal.msgList}
  title={successModal.title}
  themeId={id}         
/>

{!errorModal.isHideErrorModal && (
  <NotifyError
    isHide={errorModal.isHideErrorModal}
    handleCloseErrorModal={handleCloseErr}
    title={errorModal.title}
    message={errorModal.msg}
    Errors={errorModal.validationError}
    themeId={id}        
  />
)}
    </div>
  );
};

export default School;


